// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/ocr-a-extended/font.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/linkedin.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/instagram.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/24hr-footer.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/images/time-clock.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/images/logotype.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/images/down-arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @tailwind base;
@tailwind components;
@tailwind utilities; */
/* ! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/
html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.mb-14 {
  margin-bottom: 3.5rem;
}
.ml-\\[unset\\] {
  margin-left: unset;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.block {
  display: block;
}
.flex {
  display: flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.min-h-\\[36px\\] {
  min-height: 36px;
}
.w-full {
  width: 100%;
}
.max-w-\\[1418px\\] {
  max-width: 1418px;
}
.max-w-\\[70\\%\\] {
  max-width: 70%;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.table-auto {
  table-layout: auto;
}
.border-collapse {
  border-collapse: collapse;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-y-16 {
  row-gap: 4rem;
}
.border {
  border-width: 1px;
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(19 68 83 / var(--tw-bg-opacity));
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.text-center {
  text-align: center;
}
.font-display {
  font-family: "OCRA";
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(254 254 254 / var(--tw-text-opacity));
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
html {
  scroll-behavior: smooth;
}
body {
  --tw-bg-opacity: 1;
  background-color: rgb(254 254 254 / var(--tw-bg-opacity));
  font-family: "Inter";
  --tw-text-opacity: 1;
  color: rgb(19 68 83 / var(--tw-text-opacity));
  --tablet-breakpoint: 1024px;
  --phone-breakpoint: 768px;
  font-size: 100%;
  scroll-behavior: smooth;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#app {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
/* background and page heading according to selected theme */
#app.dark-indigo {
  --tw-bg-opacity: 1;
  background-color: rgb(30 109 133 / var(--tw-bg-opacity));
}
#app.dark-indigo .page-header {
  --tw-text-opacity: 1;
  color: rgb(234 213 179 / var(--tw-text-opacity));
}
#app.lighter-gold {
  --tw-bg-opacity: 1;
  background-color: rgb(251 246 239 / var(--tw-bg-opacity));
}
#app.lighter-gold .page-header {
  --tw-text-opacity: 1;
  color: rgb(13 48 58 / var(--tw-text-opacity));
}
#app.white {
  --tw-bg-opacity: 1;
  background-color: rgb(254 254 254 / var(--tw-bg-opacity));
}
#app.white .page-header {
  --tw-text-opacity: 1;
  color: rgb(13 48 58 / var(--tw-text-opacity));
}
footer {
  margin-top: auto;
}
*:focus-visible {
  outline-width: 1px;
  outline-offset: 4px;
  outline-color: #449FBB;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'OCRA', sans-serif;
  line-height: normal;
}
h4 {
  font-size: 1.375rem;
}
p {}
@font-face {
  font-family: 'OCRA';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "OCRA";
}
/* Make all typography responsive: */
/* Overwrite all WP typography variables on mobile */
body {
  --wp--preset--font-size--small: calc(13px * 0.8);
  --wp--preset--font-size--medium: calc(20px * 0.8);
  --wp--preset--font-size--large: calc(36px * 0.8);
  --wp--preset--font-size--x-large: calc(42px * 0.8);
  --wp--preset--font-size--heading-3-xl: calc(3.5rem * 0.8);
  --wp--preset--font-size--heading-2-xl: calc(3rem * 0.8);
  --wp--preset--font-size--heading-xl: calc(2.25rem * 0.8);
  --wp--preset--font-size--heading-tablet: calc(2.3rem * 0.8);
  --wp--preset--font-size--heading-mobile: calc(1.875rem * 0.8);
  --wp--preset--font-size--heading-l: calc(1.625rem * 0.8);
  --wp--preset--font-size--heading: calc(1.375rem * 0.8);
  --wp--preset--font-size--heading-s: calc(1rem * 0.8);
  --wp--preset--font-size--xl: calc(1.5rem * 0.8);
  --wp--preset--font-size--l: calc(1.25rem * 0.8);
  --wp--preset--font-size--normal: calc(1.125rem * 0.8);
  --wp--preset--font-size--s: calc(1rem * 0.8);
  --wp--preset--font-size--xs: calc(0.875rem * 0.8);

}
/* Overwrite all WP typography variables on tablet */
@media screen and (min-width: 768px) {
  body {
    --wp--preset--font-size--small: calc(13px * 0.9);
    --wp--preset--font-size--medium: calc(20px * 0.9);
    --wp--preset--font-size--large: calc(36px * 0.9);
    --wp--preset--font-size--x-large: calc(42px * 0.9);
    --wp--preset--font-size--heading-3-xl: calc(3.5rem * 0.9);
    --wp--preset--font-size--heading-2-xl: calc(3rem * 0.9);
    --wp--preset--font-size--heading-xl: calc(2.25rem * 0.9);
    --wp--preset--font-size--heading-tablet: calc(2.3rem * 0.9);
    --wp--preset--font-size--heading-mobile: calc(1.875rem * 0.9);
    --wp--preset--font-size--heading-l: calc(1.625rem * 0.9);
    --wp--preset--font-size--heading: calc(1.375rem * 0.9);
    --wp--preset--font-size--heading-s: calc(1rem * 0.9);
    --wp--preset--font-size--xl: calc(1.5rem * 0.9);
    --wp--preset--font-size--l: calc(1.25rem * 0.9);
    --wp--preset--font-size--normal: calc(1.125rem * 0.9);
    --wp--preset--font-size--s: calc(1rem * 0.9);
    --wp--preset--font-size--xs: calc(0.875rem * 0.9);
  }
}
/* Overwrite all WP typography variables on large screens and up */
@media screen and (min-width: 1024px) {
  body {
    --wp--preset--font-size--small: 13px;
    --wp--preset--font-size--medium: 20px;
    --wp--preset--font-size--large: 36px;
    --wp--preset--font-size--x-large: 42px;
    --wp--preset--font-size--heading-3-xl: 3.5rem;
    --wp--preset--font-size--heading-2-xl: 3rem;
    --wp--preset--font-size--heading-xl: 2.25rem;
    --wp--preset--font-size--heading-tablet: 2.3rem;
    --wp--preset--font-size--heading-mobile: 1.875rem;
    --wp--preset--font-size--heading-l: 1.625rem;
    --wp--preset--font-size--heading: 1.375rem;
    --wp--preset--font-size--heading-s: 1rem;
    --wp--preset--font-size--xl: 1.5rem;
    --wp--preset--font-size--l: 1.25rem;
    --wp--preset--font-size--normal: 1.125rem;
    --wp--preset--font-size--s: 1rem;
    --wp--preset--font-size--xs: 0.875rem;
  }
}
@keyframes fadeInAnimation {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
.site-header .nav-primary {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 2.8125rem;
  --tw-text-opacity: 1;
  color: rgb(19 68 83 / var(--tw-text-opacity));
}
@media screen and (max-width: 1023px) {

  .site-header:not(.mobile-menu--active) .nav-primary {
    opacity: 0;
  }

  .site-header.mobile-menu--active .nav-primary {
    display: flex;
    flex-direction: column;
    animation: fadeInAnimation 0.7s ease-out forwards;
  }

}
@media (orientation: landscape) and (max-height: 600px) {
  .site-menu-container {
    padding: 120px 0 70px;
    overflow: auto;
    -ms-overflow-style: none;
    /* Internet Explorer 10+ */
    scrollbar-width: none;
    /* Firefox */
  }

  .site-menu-container::-webkit-scrollbar {
    display: none;
    /* Safari and Chrome */
  }

}
.nav-primary .nav {
  display: flex;
  flex-wrap: wrap;
  gap: 2.375rem;
}
.nav-primary .nav a {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  font-family: "OCRA";
  font-size: 1.5rem;
  line-height: 2.25rem;
}
.nav-primary .nav--1 .nav a {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #1E6D85 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 109 133 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #1E6D85 var(--tw-gradient-to-position);
  background-size: 0% 0.1875rem;
  background-position-x: center;
}
.nav-primary .nav--1 .nav a:hover {
    background-size: 70% 0.1875rem;
  }
.nav-primary .nav--2 .nav a {
  --tw-bg-opacity: 1;
  background-color: rgb(30 109 133 / var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 1.125rem;
  line-height: 1.8rem;
  text-transform: uppercase;
  --tw-text-opacity: 1;
  color: rgb(251 246 239 / var(--tw-text-opacity));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
.nav-primary .nav--2 .nav a:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 254 254 / var(--tw-bg-opacity)) !important;
  --tw-text-opacity: 1;
  color: rgb(30 109 133 / var(--tw-text-opacity));
}
/* for menus */
.nav-primary .nav--1 .current-menu-item a {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #1E6D85 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 109 133 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #1E6D85 var(--tw-gradient-to-position);
  -webkit-text-decoration: none;
  text-decoration: none;
  background-position-x: center;
  background-repeat: no-repeat;
  background-size: 70% 0.1875rem;
}
/* animated menu -- start */
.nc-int-menu-to-close {
  --transition-duration: 0.5s;
}
.nc-int-menu-to-close :nth-child(1),
.nc-int-menu-to-close :nth-child(2) {
  transition: opacity 0s calc(var(--transition-duration) / 2),
    transform calc(var(--transition-duration) / 2) calc(var(--transition-duration) / 2) cubic-bezier(0.86, 0, 0.07, 1);
}
.nc-int-menu-to-close :nth-child(1) {
  transform-origin: 16px 9px;
}
.nc-int-menu-to-close :nth-child(2) {
  transform-origin: 16px 23px;
}
.nc-int-menu-to-close :nth-child(3),
.nc-int-menu-to-close :nth-child(4) {
  opacity: 0;
  transform-origin: 50% 50%;
  transition: transform calc(var(--transition-duration) / 2) cubic-bezier(0.86, 0, 0.07, 1),
    opacity 0s calc(var(--transition-duration) / 2);
}
.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(1),
.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(2) {
  transition: transform calc(var(--transition-duration) / 2) cubic-bezier(0.86, 0, 0.07, 1),
    opacity 0s calc(var(--transition-duration) / 2);
  opacity: 0;
}
.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(1) {
  transform: translateY(7px);
}
.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(2) {
  transform: translateY(-7px);
}
.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(3),
.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(4) {
  opacity: 1;
  transition: opacity 0s calc(var(--transition-duration) / 2),
    transform calc(var(--transition-duration) / 2) calc(var(--transition-duration) / 2) cubic-bezier(0.86, 0, 0.07, 1);
}
.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(3) {
  transform: rotate(45deg);
}
.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(4) {
  transform: rotate(-45deg);
}
/* animated menu -- end */
.site-header {
  display: flex;
  height: 5.9rem;
  align-items: center;
  justify-content: center;
  border-bottom-width: 0.275rem;
  --tw-border-opacity: 1;
  border-color: rgb(30 109 133 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(251 246 239 / var(--tw-bg-opacity));
}
@media (min-width: 1024px) {
  .site-header {
    height: 7.5rem;
  }
}
.site-header-container {
  display: flex;
  height: 3.8rem;
  width: 100%;
  max-width: 1420px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
@media (min-width: 1024px) {
  .site-header-container {
    margin-top: 0px;
  }
}
@media screen and (max-width: 1468px) {
  @media (min-width: 1024px) {
    .site-header-container {
      padding-left: 3rem !important;
      padding-right: 3rem !important;
    }
  }
}
.site-logo-container {
  position: absolute;
  top: 0.75rem;
  left: 1rem;
}
@media (min-width: 768px) {
  .site-logo-container {
    left: 3.25rem;
  }
}
@media (min-width: 1024px) {
  .site-logo-container {
    position: static;
  }
}
.site-menu-mobile-container {
  height: 100%;
}
.toggle-main-menu-button {
  visibility: visible;
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: inline-flex;
  height: 3.375rem;
  width: 3.375rem;
  align-items: center;
}
@media (min-width: 768px) {
  .toggle-main-menu-button {
    right: 3rem;
  }
}
@media (min-width: 1024px) {
  .toggle-main-menu-button {
    visibility: hidden;
  }
}
.custom-logo-link {
  display: block;
}
@media screen and (max-width: 1023px) {
  .site-menu-container {
    display: none;
  }

  .mobile-menu--active .site-menu-container {
    display: block;
  }

  .site-logo-container img {
    height: 3.7875rem;
  }

  .site-header {
    transition: height 0.4s ease-in-out;
  }

  .mobile-menu-is-active {
    position: fixed;
  }

  .site-header.mobile-menu--active {
    height: 100svh;
    position: absolute;
    width: 100svw;
    z-index: 999;
    top: 0;
  }

  .site-header .site-header-container {
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: unset;
    margin: 0;
  }

  .site-header.mobile-menu--active .site-logo-container {
    align-self: flex-start;
    justify-self: flex-start;
  }

  .site-header .nav {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
}
.site-footer .nav {
  display: grid;
  row-gap: 0.5rem;
  justify-content: center;
}
@media screen and (min-width: 767px) {
  .site-footer .nav {
    justify-content: start;
  }
}
.site-footer .footer-column {
  padding-left: 2rem;
  padding-right: 2rem;
  font-size: 1.25rem;
  line-height: 2rem;
}
.site-footer .footer-column a {
  --tw-text-opacity: 1;
  color: rgb(109 180 202 / var(--tw-text-opacity));
}
.site-footer .footer-column a:hover {
  --tw-text-opacity: 1;
  color: rgb(254 254 254 / var(--tw-text-opacity));
}
.site-footer .footer-column.social-media .nav {
  display: flex;
  justify-content: center;
  -moz-column-gap: 1rem;
       column-gap: 1rem;
  row-gap: 0px;
}
@media (min-width: 768px) {
  .site-footer .footer-column.social-media .nav {
    justify-content: flex-start;
  }
}
.site-footer .social-media--item {
  height: 2.5rem;
  border-radius: 9px;
}
.site-footer .social-media--item::before {
  height: 4rem;
  width: 4rem;
  --tw-bg-opacity: 1;
  background-color: rgb(68 159 187 / var(--tw-bg-opacity));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
.site-footer .social-media--item:hover::before {
  --tw-bg-opacity: 1;
  background-color: rgb(251 246 239 / var(--tw-bg-opacity));
}
.site-footer .social-media--item::before {
  content: '';
  display: inline-block;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
}
.site-footer .social-media--linkedin::before {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.site-footer .social-media--instagram::before {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.site-footer .social-media--24hr::before {
  width: 5rem;
}
@media (min-width: 768px) {
  .site-footer .social-media--24hr::before {
    width: 7rem;
  }
}
.site-footer .social-media--24hr::before {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  -webkit-mask-size: contain;
          mask-size: contain;
}
/* sign up button */
.site-footer .footer-column.column--2 menu li {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  --tw-bg-opacity: 1;
  background-color: rgb(30 109 133 / var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-family: "OCRA";
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
.site-footer .footer-column.column--2 menu li:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 246 239 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(30 109 133 / var(--tw-text-opacity));
}
@media (min-width: 768px) {
  .site-footer .footer-column.column--2 menu li {
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-left: 1.5rem;
  }
}
.site-footer .footer-column.column--2 menu li {
  display: inline-block;
  padding-right: calc(1.5rem + 1.25rem);
  -webkit-clip-path: polygon(0 0, 100% 0, calc(100% - 1.25rem) 100%, 0 100%);
          clip-path: polygon(0 0, 100% 0, calc(100% - 1.25rem) 100%, 0 100%)
}
.site-footer .footer-column.column--2 menu li:hover a {
  --tw-text-opacity: 1;
  color: rgb(30 109 133 / var(--tw-text-opacity));
}
.site-footer .footer-column.column--2 menu li a {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  --tw-text-opacity: 1;
  color: rgb(251 246 239 / var(--tw-text-opacity));
}
.site-footer .footer-column.column--2 menu li a:hover {
  --tw-text-opacity: 1;
  color: rgb(30 109 133 / var(--tw-text-opacity));
}
/* end


/* for menus */
.site-footer .column--1 .current-menu-item a {
  --tw-text-opacity: 1;
  color: rgb(251 246 239 / var(--tw-text-opacity));
  -webkit-text-decoration: none;
  text-decoration: none;
  background-image: linear-gradient(currentColor, currentColor);
  background-position: 0% 100%;
  background-repeat: no-repeat;
  background-size: 100% 0.125rem;
}
/* smaller icons and button on mobile */
@media screen and (max-width:767px) {
  .site-footer .footer-column.column--2 menu li a {
    font-size: 1.225rem;
    padding: 0.75rem;
  }

  .site-footer a.social-media--linkedin::before,
  .site-footer a.social-media--instagram::before {
    height: 3rem;
    width: 3rem;
    -webkit-mask-size: contain;
            mask-size: contain;
  }

  .site-footer .footer-column.column--2 menu li {
    padding-right: 2rem;
  }

}
.button {
  transition: all 0.3s ease-in-out;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  font-size: 1.375rem;
  padding: 1rem 1.5rem;
  background-color: var(--button-primary-color);
  color: var(--primary-text-color);
  font-family: 'OCRA';
}
.button.tilt-right {
  -webkit-clip-path: polygon(0 0, 100% 0, calc(100% - 1.25rem) 100%, 0 100%);
          clip-path: polygon(0 0, 100% 0, calc(100% - 1.25rem) 100%, 0 100%)
}
.button.tilt-left {
  -webkit-clip-path: polygon(0% 0%, 100% 0, 100% 100%, 0.75rem 100%);
          clip-path: polygon(0% 0%, 100% 0, 100% 100%, 0.75rem 100%);
}
/* color variants */
/* .button:hover {
  background-color: var(--secondary-text-color) !important;
  color: var(--secondary-color) !important;
} */
.button.primary {
  background-color: var(--button-primary-color);
  color: var(--primary-text-color);
}
.button:hover, button.primary:hover {
  background-color: var(--button-primary-hover)
}
.button.secondary {
  background-color: var(--secondary-color);
  color: var(--secondary-text-color);
}
.button.secondary:hover {
  background-color: var(--button-dark-color);
}
.button.dark {
  background-color: var(--dark-color);
  color: var(--dark-text-color);
}
/* size variants */
.button.large {
  font-size: 1.375rem;
  padding: 1rem 1.5rem;
}
.button.small {
  font-size: 1.225rem;
  padding: 0.75rem 1rem;
}
.button.tilt-right {
    padding-right: calc(1.5rem + 1.25rem);
}
.button.small.tilt-right {
    padding-right: calc(1rem + 1.25rem);
}
.button.tilt-left {
  padding-left: calc(1.5rem + 0.75rem);
}
.button.small.tilt-left {
  padding-left: calc(1rem + 0.75rem);
}
.page-header h1 {
  margin-left: 0px;
  margin-right: 0px;
  max-width: 934px;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 4rem;
  text-align: center;
  font-family: "OCRA";
  font-size: 1.875rem;
}
@media (min-width: 768px) {
  .page-header h1 {
    padding-left: 3rem;
    padding-right: 3rem;
  }
}
@media (min-width: 1024px) {
  .page-header h1 {
    margin-left: auto;
    margin-right: auto;
    padding-left: 4rem;
    padding-right: 4rem;
    padding-top: 8.125rem;
    text-align: center;
    font-size: 3rem;
    line-height: 3.6rem;
  }
}
.page-header.page-header--hidden {
  display: none;
}
.section {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
  max-width: 1420px;
}
/* .gutenberg {
    @apply mx-8
    md:mx-12
    lg:mx-16;
} */
.paragraph.large {
  max-width: 55rem;
}
.paragraph {
  margin-left: 0px;
  margin-right: 0px;
  text-align: left;
}
@media (min-width: 1024px) {
  .paragraph {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
}
.desktop-center-mobile-left {
  text-align: left;
}
@media (min-width: 1024px) {
  .desktop-center-mobile-left {
    text-align: center;
  }
}
.desktop-center-mobile-left--flex {
  justify-content: flex-start;
}
@media (min-width: 1024px) {
  .desktop-center-mobile-left--flex {
    justify-content: center;
  }
}
/* hero-text less wide on tablet */
@media screen and (min-width: 600px) and (max-width: 1023px) {
  .hero-text-container {
    max-width: 80%;
    margin: auto;
  }
}
/* styling only for 404 page */
body.error404 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 246 239 / var(--tw-bg-opacity));
}
body.error404 .page-header {
  padding-bottom: 2rem;
}
:root {
    --indigo-primary: #1e6d85;
    --indigo-dark: #134453;
    --gold-primary: #cdb285;
    --gray-dark: #262626;
    --white: #ffffff;
  }
/* styling for menu links */
menu p a {
   color: var(--indigo-primary) !important;
 }
menu p a,
 .animated-underline a,
 .animated-underline {
   -webkit-text-decoration: none;
   text-decoration: none;
   background-image: linear-gradient(currentColor, currentColor);
   background-position: 0% 100%;
   background-repeat: no-repeat;
   background-size: 0% 2px;
   transition: background-size .3s;
 }
menu p a:hover,
 .animated-underline a:hover,
 .animated-hover-item:hover .animated-underline,
 .animated-hover-item:focus .animated-underline,
 .animated-hover-item:active .animated-underline,
 .animated-hover-item:focus-visible .animated-underline {
   background-size: 100% 0.125rem;
   transition-delay: 0s;
 }
/* styling for links in text body */
p:not(.menu)>a,
 .single-event .event-content-container li:not(.menu) a,
 a.body-link {
   --ease-out-expo: cubic-bezier(0.19, 1, 0.22, 1);
   position: relative;
   color: var(--indigo-primary) !important;
 }
p:not(.menu)>a::before,
 p:not(.menu)>a::after,
 .single-event .event-content-container li:not(.menu) a::before,
 .single-event .event-content-container li:not(.menu) a::after,
 a.body-link::before,
 a.body-link::after {
   content: "";
   position: absolute;
   left: 0;
   bottom: -0.15rem;
   display: block;
   width: 100%;
   height: 1px;
   background: var(--indigo-primary);
   transition: 0.5s var(--ease-out-expo);
 }
p:not(.menu)>a::before,
 .single-event .event-content-container li:not(.menu) a::before,
 a.body-link::before {
   transform: scaleX(0);
   transform-origin: left;
 }
p:not(.menu)>a::after,
 .single-event .event-content-container li:not(.menu) a::after,
 a.body-link::after {
   transform-origin: right;
   transition-delay: 0.25s;
 }
p:not(.menu)>a:hover::before,
 .single-event .event-content-container li:not(.menu) a:hover::before,
 a.body-link:hover::before {
   transform: scaleX(1);
   transition-delay: 0.25s;
 }
p:not(.menu)>a:hover::after,
 .single-event .event-content-container li:not(.menu) a:hover::after,
 a.body-link:hover::after {
   transform: scaleX(0);
   transition-delay: 0s;
 }
/* for links with light text */
a.body-link.light-text {
   color: inherit !important;
 }
a.body-link.light-text::before,
 a.body-link.light-text::after {
   background-color: white !important;
 }
body:has(.single-event) {
  --tw-bg-opacity: 1;
  background-color: rgb(251 246 239 / var(--tw-bg-opacity));
}
.single-event .event-section {
  margin-left: auto;
  margin-right: auto;
  max-width: 1420px;
}
/* grid for lg screens */
@media screen and (min-width: 1024px) {

  .single-event .event-content-container {
    display: grid;
    grid-template-columns: 1.5fr 1fr;
  }

}
.single-event .event-section .event-content-container {
  max-width: 1420px;
  padding-top: 4rem;
}
@media (min-width: 1024px) {
  .single-event .event-section .event-content-container {
    -moz-column-gap: 4rem;
         column-gap: 4rem;
    padding-left: 3rem;
    padding-right: 3rem;
    padding-top: 8.375rem;
  }
}
.single-event .event-info-container {
  padding-left: 6svw;
  padding-right: 6svw;
}
@media (min-width: 640px) {
  .single-event .event-info-container {
    padding-left: 10svw;
    padding-right: 10svw;
  }
}
@media screen and (min-width: 1024px) {
  .single-event .event-info-container {
    padding: unset;
  }
}
/* event date location details */
.single-event .event-details-container {
  margin-bottom: 1.25rem;
  font-size: 1.15rem;
  --tw-text-opacity: 1;
  color: rgb(254 254 254 / var(--tw-text-opacity));
}
.single-event .event-details-container td.event-details-label {
  padding-right: 1rem;
  --tw-text-opacity: 1;
  color: rgb(234 213 179 / var(--tw-text-opacity));
}
.single-event .event-details-container tr.table-spacing td {
  padding-bottom: 0.625rem;
}
.single-event .event-details-container table {
  margin-bottom: 3.5rem;
}
@media (min-width: 1024px) {
  .single-event .event-details-container table {
    margin-bottom: 2.75rem;
  }
}
.single-event .event-details-container table .event-details-label-col {
  width: 30%;
}
.single-event .event-details-container table .full-width {
  width: 100%;
}
.single-event .event-sponsor img {
  height: auto;
  width: 8rem;
}
@media (min-width: 768px) {
  .single-event .event-sponsor img {
    width: 10rem;
  }
}
.single-event .event-extra-info {
  margin-bottom: 1rem;
  font-size: 1.125rem;
  line-height: 1.8rem;
  font-style: italic;
}
@media (min-width: 1024px) {
  .single-event .event-extra-info {
    margin-bottom: 2rem;
  }
}
/* form */
.event-form-container {
  min-width: 24rem;
  margin-bottom: 4rem;
}
.single-event .event-form-container .event-form {
  position: sticky;
  top: 1rem;
  --tw-bg-opacity: 1;
  background-color: rgb(30 109 133 / var(--tw-bg-opacity));
  padding: 1.25rem;
  font-family: "Inter";
}
@media (min-width: 1024px) {
  .single-event .event-form-container .event-form {
    border-radius: 1.5rem;
    padding: 2.25rem;
    padding-bottom: 4rem;
  }
}
@media screen and (max-width: 1023px) {
  .single-event .event-form-container .event-form {
    padding-bottom: 4rem;
  }

  @media (min-width: 1024px) {
    .single-event .event-form-container {
      padding-right: 4rem;
    }
  }
}
.event-form-title {
  margin-bottom: 2rem;
  margin-top: 2.25rem;
  font-size: 1.5rem;
  line-height: 2.4rem;
  --tw-text-opacity: 1;
  color: rgb(254 254 254 / var(--tw-text-opacity));
}
@media (min-width: 1024px) {
  .event-form-title {
    margin-bottom: 2rem;
    margin-top: 0px;
  }
}
.single-event .event-form .fallback-message-container p.fallback-message {
  padding-top: 1.5rem;
  font-family: "OCRA";
  font-size: 1.3rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(234 213 179 / var(--tw-text-opacity));
}
@media (min-width: 768px) {
  .single-event .event-form .fallback-message-container p.fallback-message {
    padding-top: 0px;
    font-size: 1.5rem;
  }
}
/* content */
.single-event .event-title {
  margin-bottom: 1.5rem;
  font-size: 1.875rem;
  --tw-text-opacity: 1;
  color: rgb(30 109 133 / var(--tw-text-opacity));
}
@media (min-width: 768px) {
  .single-event .event-title {
    font-size: 2.3rem;
    line-height: 2.7rem;
  }
}
@media (min-width: 1024px) {
  .single-event .event-title {
    font-size: 3rem;
    line-height: 3.6rem;
  }
}
.single-event .event-ingress-container {
  margin-bottom: 3.25rem;
  max-width: 60rem;
}
.single-event .event-ingress-container * {
  font-size: 1.25rem;
  line-height: 2rem;
  --tw-text-opacity: 1;
  color: rgb(38 38 38 / var(--tw-text-opacity));
}
@media (min-width: 1024px) {
  .single-event .event-ingress-container * {
    font-size: 1.5rem;
    line-height: 2.4rem;
  }
}
.single-event .event-ingress-container ol,
.single-event .event-ingress-container ul,
.single-event .event-description-container ol,
.single-event .event-description-container ul {
  margin: 2em 0;
  padding-left: 4rem;
}
.single-event .event-content-container ol {
  list-style: decimal;
}
.single-event .event-content-container ul {
  list-style: disc;
}
.single-event .event-ingress-container li,
.single-event .event-description-container li {
  margin-bottom: 0.3em;
}
.single-event .event-image-container img {
  margin-bottom: 3rem;
  width: 100%;
  border-radius: 1.5rem;
}
.single-event .event-description-container {
  margin-bottom: 3rem;
  font-size: 1.125rem;
  line-height: 1.8rem;
  --tw-text-opacity: 1;
  color: rgb(13 48 58 / var(--tw-text-opacity));
}
.single-event .event-sponsors-container {
  margin-bottom: 4.5rem;
}
.single-event .event-sponsors-container fieldset {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  row-gap: 2.5rem;
  border-top-width: 1px;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(205 178 133 / var(--tw-border-opacity));
  padding: 2.25rem;
  padding-top: 2rem;
}
@media (min-width: 1024px) {
  .single-event .event-sponsors-container fieldset {
    flex-direction: row;
  }
}
.single-event .event-sponsors-container fieldset legend {
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.225rem;
  --tw-text-opacity: 1;
  color: rgb(19 68 83 / var(--tw-text-opacity));
}
.single-event .event-extra-container {
  margin-bottom: 4.5rem;
}
/* sponsors block */
.event-sponsors-container {
  margin-bottom: 3rem;
}
body:has(.event-archive) {
  --tw-bg-opacity: 1;
  background-color: rgb(251 246 239 / var(--tw-bg-opacity));
}
.event-archive {
  display: flex;
  width: 100%;
  justify-content: center;
}
.event-list-wrapper {
  text-align: center;
}
.event-archive-container {
  margin-left: 2rem;
  margin-right: 2rem;
  margin-top: 4rem;
  margin-bottom: 4rem;
  width: 100%;
  max-width: 1420px;
}
@media (min-width: 768px) {
  .event-archive-container {
    margin-left: 3rem;
    margin-right: 3rem;
  }
}
@media (min-width: 1024px) {
  .event-archive-container {
    margin-left: 4rem;
    margin-right: 4rem;
    margin-top: 8.375rem;
    margin-bottom: 8.375rem;
  }
}
.event-archive-info-container {
  margin-bottom: 2rem;
}
.event-archive-title {
  margin-bottom: 1.5rem;
  font-family: "OCRA";
  font-size: 1.875rem;
}
@media (min-width: 1024px) {
  .event-archive-title {
    margin-bottom: 0.5rem;
    font-size: 3rem;
    line-height: 3.6rem;
  }
}
.event-archive-ingress-container {
  margin-bottom: 3rem;
  max-width: 60rem;
}
@media (min-width: 1024px) {
  .event-archive-ingress-container {
    margin-bottom: 4.5rem;
  }
}
.event-archive-ingress {
  font-size: 1.25rem;
  line-height: 2rem;
}
@media (min-width: 1024px) {
  .event-archive-ingress {
    font-size: 1.5rem;
    line-height: 2.4rem;
  }
}
.event-list-wrapper .post-list-container {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  row-gap: 2rem;
  -moz-column-gap: 2rem;
       column-gap: 2rem;
}
@media (min-width: 640px) {
  .event-list-wrapper .post-list-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 1024px) {
  .event-list-wrapper .post-list-container {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (min-width: 1280px) {
  .event-list-wrapper .post-list-container {
    -moz-column-gap: 3rem;
         column-gap: 3rem;
    row-gap: 4rem;
  }
}
/* single event item */
.event-list-single-container,
.event-list-single-container a {
  border-radius: 1.5rem;
}
.event-list-single-container img,
.event-list-single-container .image-placeholder {
  aspect-ratio: 445/305;
  width: 100%;
  border-radius: 1.5rem;
  object-fit: cover;
  opacity: 1;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
.event-list-single-container:hover img,
.event-list-single-container:active img,
.event-list-single-container:focus-visible img {
  opacity: 85%;
}
/* .event-list-single-container img.passed-event-img {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
} */
.event-list-single-container .event-list-single-heading {
  margin-bottom: 0.75rem;
  text-align: start;
  font-size: 1.625rem;
  line-height: 1.95rem;
  --tw-text-opacity: 1;
  color: rgb(30 109 133 / var(--tw-text-opacity));
}
.event-list-single-container .event-list-single-date {
  display: flex;
  align-items: center;
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
  font-size: 1rem;
  line-height: 1.6rem;
  --tw-text-opacity: 1;
  color: rgb(19 68 83 / var(--tw-text-opacity));
}
.event-list-single-container .event-list-single-info-container {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.event-list-single-date span::before {
  margin-inline-end: 0.5rem;
  height: 1rem;
  width: 1rem;
  --tw-bg-opacity: 1;
  background-color: rgb(30 109 133 / var(--tw-bg-opacity));
  content: '';
  display: inline-block;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  transform: translateY(2px);
}
.product-list-single-container .image-placeholder {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: 50%;
  background-repeat: no-repeat;
  background-position: center;
}
.event-archive .button {
  margin-top: 4rem;
}
[data-no-event-placeholder] {
  font-family: "OCRA";
  font-size: 1.2rem;
  --tw-text-opacity: 1;
  color: rgb(19 68 83 / var(--tw-text-opacity));
}
@media (min-width: 1024px) {
  [data-no-event-placeholder] {
    font-size: 1.5rem;
  }
}
.person-archive {
  display: flex;
  width: 100%;
  justify-content: center;
}
.person-list-wrapper {
  text-align: center;
}
.person-archive-container {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
  margin-top: 4rem;
  margin-bottom: 4rem;
  width: 100%;
  max-width: 1420px;
}
@media (min-width: 1024px) {
  .person-archive-container {
    margin-top: 130px;
    margin-bottom: 130px;
  }
}
.person-archive-info-container {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 4.365rem;
  text-align: center;
}
@media (min-width: 1024px) {
  .person-archive-info-container {
    margin-bottom: 4.875rem;
  }
}
.person-archive-title {
  margin-bottom: 1.5rem;
  font-family: "OCRA";
  font-size: 1.875rem;
}
@media (min-width: 1024px) {
  .person-archive-title {
    margin-bottom: 0.875rem;
    font-size: 3rem;
    line-height: 3.6rem;
  }
}
.person-archive-ingress-container {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 3rem;
  max-width: 860px;
  font-size: 1.25rem;
  line-height: 2rem;
}
@media (min-width: 1024px) {
  .person-archive-ingress-container {
    margin-bottom: 6.25rem;
  }
}
.person-archive-container .post-filters-container {
  margin-left: auto;
  margin-right: auto;
  width: -moz-fit-content;
  width: fit-content;
}
/* single person item */
.person-list-single-container, .person-list-single-container a {
  border-radius: 1.5rem;
}
.person-list-single-container img,
.person-list-single-container .image-placeholder {
  margin-bottom: 1.25rem;
  aspect-ratio: 445/305;
  width: 100%;
  border-radius: 1.5rem;
  object-fit: cover;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
.post-filters {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
}
@media (min-width: 1024px) {
  .post-filters {
    justify-content: flex-start;
  }
}
.post-filters button,
.post-filter-select {
  display: inline-block;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(30 109 133 / var(--tw-border-opacity));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-family: "OCRA";
  font-size: 1rem;
  line-height: 1.6rem;
  --tw-text-opacity: 1;
  color: rgb(30 109 133 / var(--tw-text-opacity));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
.post-filters button:hover,
.post-filter-select:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 109 133 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(251 246 239 / var(--tw-text-opacity));
}
@media (min-width: 1024px) {
  .post-filters button,
.post-filter-select {
    font-size: 1.125rem;
    line-height: 1.8rem;
  }
}
.post-filter-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Remove default arrow */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-position: center right 9px;
  padding-right: 35px;
  background-size: 0.7rem;
  border-radius: 0;
  /* Add custom arrow */
  --tw-bg-opacity: 1;
  background-color: rgb(251 246 239 / var(--tw-bg-opacity));
}
.post-filter-select:hover {
  background-color: unset;
  color: unset;
}
.post-filter-select::-ms-expand {
  display: none;
  /* Hide the default arrow in Internet Explorer 10 and Internet Explorer 11 */
}
.post-filters button.is-current-filter {
  --tw-bg-opacity: 1;
  background-color: rgb(30 109 133 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(251 246 239 / var(--tw-text-opacity));
}
/* target on blocks with the custom Contact block */
.wp-block-group:has(.contact-block) {
  -moz-column-gap: 4rem;
       column-gap: 4rem;
}
.wp-container-4.wp-container-4:has(.contact-block),
.wp-container-6.wp-container-6:has(.contact-block),
.wp-container-8.wp-container-8:has(.contact-block) {
  flex-wrap: wrap;
}
@media screen and (max-width: 1024px) {
    .wp-block-group:has(.contact-block) {
    flex-wrap: wrap;
  }
}
form input,
form textarea,
.mc4wp-form-fields input,
.mc4wp-form-fields select {
  --tw-bg-opacity: 1;
  background-color: rgb(19 68 83 / var(--tw-bg-opacity));
  font-family: "Inter";
  font-size: 1rem;
  line-height: 1.6rem;
  --tw-text-opacity: 1;
  color: rgb(234 213 179 / var(--tw-text-opacity));
  background-color: var(--indigo-dark) !important;
  border: 0 !important;
  border-radius: 0 !important;
}
form input::placeholder, form textarea::placeholder, .mc4wp-form-fields input::placeholder, .mc4wp-form-fields select::placeholder {
  --tw-text-opacity: 1;
  color: rgb(234 213 179 / var(--tw-text-opacity));
}
form *:focus {
  outline-style: solid;
  outline-color: #CDB285;
}
.mauticform-textarea {
  min-height: 104px !important;
}
/* mc4wp form */
.mc4wp-form-fields input,
.mc4wp-form-fields select {
  margin-bottom: 20px;
  width: 100%;
  padding: 0.5em;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition-delay: 9999s;
}
.mc4wp-alert {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
}
.mc4wp-alert>p {
  border-top-width: 1px;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(234 213 179 / var(--tw-border-opacity));
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgb(234 213 179 / var(--tw-text-opacity));
}
/* button */
form button,
.single-event .event-form button[type=button].eventbrite-button,
.mc4wp-form-fields input[type=submit] {
  width: 100%;
  font-family: "OCRA";
  font-weight: 400;
  background-color: var(--gold-primary) !important;
  border: 0 !important;
  color: var(--gray-dark) !important;
  padding: 1rem !important;
  border-radius: 3px !important;
  margin-top: 0.5em;
  max-width: 40rem;
}
form button:hover, .single-event .event-form button[type=button].eventbrite-button:hover, .mc4wp-form-fields input[type=submit]:hover {
    filter: brightness(90%);
    cursor: pointer;
  }
.mauticform-button,
.single-event .event-form button[type=button].eventbrite-button,
.mc4wp-form-fields input[type=submit] {
  font-weight: 400;
  font-size: 1.375rem !important;
  /* 22px */
  line-height: 1.925rem !important;
  /* 30.8px */
}
/* button end */
@media screen and (max-width: 768px) {

  .single-event .event-form button[type=button].eventbrite-button,
  .mc4wp-form-fields input[type=submit] {
    font-size: 1.15rem !important;
  }

  /* form width */
  form {
    width: 100% !important;
    margin: 0 !important;
  }

  .mauticform_wrapper {
    max-width: unset !important;
  }
}
/* form width end */
/* checkbox */
/* Hide the default checkbox */
input[type="checkbox"].mauticform-checkboxgrp-checkbox {
  display: none;
}
/* Style for the custom checkbox */
.mauticform-checkboxgrp-label {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  display: inline-block;
  line-height: 1.5;
}
/* Style for the custom checkbox */
.mauticform-checkboxgrp-label::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  height: 20px;
  width: 20px;
  background-color: transparent;
  border: 1px solid var(--gold-primary);
  display: block;
}
.mauticform-checkboxgrp-label::after,
.mauticform-checkboxgrp-label::after {
  /* currently not working on desktop for reasons unknown */
  z-index: 10;
  font-family: "OCRA";
  content: "";
  position: absolute;
  top: -4px;
  left: 3px;
  color: white;
  font-size: 22px;
  display: block !important;
}
/* Show the custom checkmark when the checkbox is checked */
input[type="checkbox"]:checked~.mauticform-checkboxgrp-label::after,
input[type="checkbox"]:checked~.mauticform-checkboxgrp-label::after,
.box-is-checked {
  display: block !important;
  content: "\\2713";
}
/* checkbox end */
/* @media screen and (max-width: 1024px) {
    .wp-block-cover {
        min-height: unset !important;
        padding: 0;

        img {
            position: relative !important;
            height: auto !important;
            width: 100% !important;
        }
    }
} */
/*
 !IMPORTANT!
 If you add classes here, please add a description of them in the documentation at:
 custom_classes_documentation_function() in services/wordpress/src/wp-content/themes/techella-wp/app/setup.php
*/
.diagonal-section {
  -webkit-clip-path: polygon(0 20%, 100% 0, 100% 80%, 0 100%);
          clip-path: polygon(0 20%, 100% 0, 100% 80%, 0 100%);
  -webkit-backface-visibility: hidden;
  /* This settings smoothes the edge out in Chrome - otherwise it looks very jagged */
}
.border-radius {
  border-radius: 1.5rem;
}
/*
*    Responsive
*/
.desktop-only,
.desktop-only--flex {
  display: none !important;
}
.mobile-only {
  display: block !important;
}
.mobile-only--flex {
  display: flex !important;
}
.section {
  width: 100%;
  max-width: 88.75rem;
  margin-left: 1.25rem !important;
  margin-right: 1.25rem !important;
}
@media screen and (max-width: 1420px) {
  @media (min-width: 1024px) {
    .section {
      padding-left: 3.25rem !important;
      padding-right: 3.25rem !important;
    }
  }
}
.drop-shadow {
  filter: drop-shadow(24px 24px 0px #1E6D85);
}
@media screen and (min-width: 1024px) {
  .desktop-only--flex {
    display: flex !important;
  }

  .desktop-only {
    display: block !important;
  }

  .mobile-only--flex,
  .mobile-only {
    display: none !important;
  }

}
.wp-block-column.is-layout-flow.hero-text-container {
  justify-content: flex-end;
  overflow-y: auto;
}
/* funkar inte trots alla dessa klasser att inte använda !important: */
.wp-block-column.is-layout-flow.hero-text-container .left-padding {
  padding-left: 3.25rem;
}
@media screen and (min-width: 1500px) {
  .wp-block-column.is-layout-flow.hero-text-container .wp-block-group.left-padding {
    width: calc(1420px / 2);
  }
}
.center-content {
  display: flex;
  justify-content: center;
}
/* only visible on 1024< screen width */
.hero-section {
  height: calc(100svh - 120px);
}
.hero-section .wp-block-column {
    height: 100%;
  }
.hero-section .wp-block-column .wp-block-cover {
      height: 100%;
    }
.hero-section .hero-text-container {
    display: flex;
    align-items: center;
  }
@media screen and (max-width: 1024px) {
  @media (min-width: 768px) {
    .social-icons-block .wp-block-cover {
      padding-left: 5svw;
      padding-right: 5svw;
    }
  }
  .social-icons-block .wp-block-cover {
    min-height: unset !important;
    padding: 0 2svw;
  }
}
/* Partners page */
@media screen and (max-width: 600px) {
  #partners-group .wp-block-media-text figure {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem !important;
  }

    #partners-group .wp-block-media-text figure>img {
      max-width: 70%;
    }
}
@media screen and (min-width:601px) and (max-width: 980px) {
  #partners-group .wp-block-media-text {
    margin-left: 3rem !important;
  }
}
#app {
  position: relative;
}
.focus\\:not-sr-only:focus {
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
@media (min-width: 640px) {
  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (min-width: 768px) {
  .md\\:mt-20 {
    margin-top: 5rem;
  }
  .md\\:flex {
    display: flex;
  }
  .md\\:max-w-\\[600px\\] {
    max-width: 600px;
  }
  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:justify-center {
    justify-content: center;
  }
}
@media (min-width: 1024px) {
  .lg\\:ml-\\[3rem\\] {
    margin-left: 3rem;
  }
  .lg\\:mt-24 {
    margin-top: 6rem;
  }
  .lg\\:mt-\\[unset\\] {
    margin-top: unset;
  }
  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:flex-row {
    flex-direction: row;
  }
  .lg\\:items-start {
    align-items: flex-start;
  }
  .lg\\:justify-start {
    justify-content: flex-start;
  }
  .lg\\:justify-between {
    justify-content: space-between;
  }
  .lg\\:gap-y-0 {
    row-gap: 0px;
  }
  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }
  .lg\\:text-left {
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./styles/app.css"],"names":[],"mappings":"AAAA;;sBAEsB;AACtB,iEAAiE;AACjE;;;CAGC;AACD;;;EAGE,sBAAsB,EAAE,MAAM;EAC9B,eAAe,EAAE,MAAM;EACvB,mBAAmB,EAAE,MAAM;EAC3B,0BAA0B,EAAE,MAAM;AACpC;AACA;;EAEE,gBAAgB;AAClB;AACA;;;;;;;CAOC;AACD;EACE,gBAAgB,EAAE,MAAM;EACxB,8BAA8B,EAAE,MAAM;EACtC,gBAAgB,EAAE,MAAM;EACxB,WAAW,EAAE,MAAM;EACnB,4NAA4N,EAAE,MAAM;EACpO,6BAA6B,EAAE,MAAM;EACrC,+BAA+B,EAAE,MAAM;AACzC;AACA;;;CAGC;AACD;EACE,SAAS,EAAE,MAAM;EACjB,oBAAoB,EAAE,MAAM;AAC9B;AACA;;;;CAIC;AACD;EACE,SAAS,EAAE,MAAM;EACjB,cAAc,EAAE,MAAM;EACtB,qBAAqB,EAAE,MAAM;AAC/B;AACA;;CAEC;AACD;EACE,0BAA0B;EAC1B,yCAAyC;UACjC,iCAAiC;AAC3C;AACA;;CAEC;AACD;;;;;;EAME,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;CAEC;AACD;EACE,cAAc;EACd,wBAAwB;AAC1B;AACA;;CAEC;AACD;;EAEE,mBAAmB;AACrB;AACA;;;CAGC;AACD;;;;EAIE,+GAA+G,EAAE,MAAM;EACvH,cAAc,EAAE,MAAM;AACxB;AACA;;CAEC;AACD;EACE,cAAc;AAChB;AACA;;CAEC;AACD;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;;;;CAIC;AACD;EACE,cAAc,EAAE,MAAM;EACtB,qBAAqB,EAAE,MAAM;EAC7B,yBAAyB,EAAE,MAAM;AACnC;AACA;;;;CAIC;AACD;;;;;EAKE,oBAAoB,EAAE,MAAM;EAC5B,8BAA8B,EAAE,MAAM;EACtC,gCAAgC,EAAE,MAAM;EACxC,eAAe,EAAE,MAAM;EACvB,oBAAoB,EAAE,MAAM;EAC5B,oBAAoB,EAAE,MAAM;EAC5B,cAAc,EAAE,MAAM;EACtB,SAAS,EAAE,MAAM;EACjB,UAAU,EAAE,MAAM;AACpB;AACA;;CAEC;AACD;;EAEE,oBAAoB;AACtB;AACA;;;CAGC;AACD;;;;EAIE,0BAA0B,EAAE,MAAM;EAClC,6BAA6B,EAAE,MAAM;EACrC,sBAAsB,EAAE,MAAM;AAChC;AACA;;CAEC;AACD;EACE,aAAa;AACf;AACA;;CAEC;AACD;EACE,gBAAgB;AAClB;AACA;;CAEC;AACD;EACE,wBAAwB;AAC1B;AACA;;CAEC;AACD;;EAEE,YAAY;AACd;AACA;;;CAGC;AACD;EACE,6BAA6B,EAAE,MAAM;EACrC,oBAAoB,EAAE,MAAM;AAC9B;AACA;;CAEC;AACD;EACE,wBAAwB;AAC1B;AACA;;;CAGC;AACD;EACE,0BAA0B,EAAE,MAAM;EAClC,aAAa,EAAE,MAAM;AACvB;AACA;;CAEC;AACD;EACE,kBAAkB;AACpB;AACA;;CAEC;AACD;;;;;;;;;;;;;EAaE,SAAS;AACX;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;;CAEC;AACD;EACE,UAAU;AACZ;AACA;;CAEC;AACD;EACE,gBAAgB;AAClB;AACA;;;CAGC;AACD;;EAEE,UAAU,EAAE,MAAM;EAClB,cAAc,EAAE,MAAM;AACxB;AACA;;CAEC;AACD;;EAEE,eAAe;AACjB;AACA;;CAEC;AACD;EACE,eAAe;AACjB;AACA;;;;CAIC;AACD;;;;;;;;EAQE,cAAc,EAAE,MAAM;EACtB,sBAAsB,EAAE,MAAM;AAChC;AACA;;CAEC;AACD;;EAEE,eAAe;EACf,YAAY;AACd;AACA,wEAAwE;AACxE;EACE,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,0EAA0E;EAC1E,8FAA8F;EAC9F,uGAAuG;AACzG;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kGAAkG;EAClG,iLAAiL;AACnL;AACA;EACE,iLAAiL;AACnL;AACA;EACE,gKAAgK;EAChK,wJAAwJ;EACxJ,iLAAiL;EACjL,wDAAwD;EACxD,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,yDAAyD;EACzD,oBAAoB;EACpB,oBAAoB;EACpB,6CAA6C;EAC7C,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;AACA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;;;;;;EAME,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA,GAAG;AACH;EACE,mBAAmB;EACnB,4DAA8D;AAChE;AACA;;;;;;EAME,mBAAmB;AACrB;AACA,oCAAoC;AACpC,oDAAoD;AACpD;EACE,gDAAgD;EAChD,iDAAiD;EACjD,gDAAgD;EAChD,kDAAkD;EAClD,yDAAyD;EACzD,uDAAuD;EACvD,wDAAwD;EACxD,2DAA2D;EAC3D,6DAA6D;EAC7D,wDAAwD;EACxD,sDAAsD;EACtD,oDAAoD;EACpD,+CAA+C;EAC/C,+CAA+C;EAC/C,qDAAqD;EACrD,4CAA4C;EAC5C,iDAAiD;;AAEnD;AACA,oDAAoD;AACpD;EACE;IACE,gDAAgD;IAChD,iDAAiD;IACjD,gDAAgD;IAChD,kDAAkD;IAClD,yDAAyD;IACzD,uDAAuD;IACvD,wDAAwD;IACxD,2DAA2D;IAC3D,6DAA6D;IAC7D,wDAAwD;IACxD,sDAAsD;IACtD,oDAAoD;IACpD,+CAA+C;IAC/C,+CAA+C;IAC/C,qDAAqD;IACrD,4CAA4C;IAC5C,iDAAiD;EACnD;AACF;AACA,kEAAkE;AAClE;EACE;IACE,oCAAoC;IACpC,qCAAqC;IACrC,oCAAoC;IACpC,sCAAsC;IACtC,6CAA6C;IAC7C,2CAA2C;IAC3C,4CAA4C;IAC5C,+CAA+C;IAC/C,iDAAiD;IACjD,4CAA4C;IAC5C,0CAA0C;IAC1C,wCAAwC;IACxC,mCAAmC;IACnC,mCAAmC;IACnC,yCAAyC;IACzC,gCAAgC;IAChC,qCAAqC;EACvC;AACF;AACA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,6CAA6C;AAC/C;AACA;;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iDAAiD;EACnD;;AAEF;AACA;EACE;IACE,qBAAqB;IACrB,cAAc;IACd,wBAAwB;IACxB,0BAA0B;IAC1B,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;AAEF;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,qEAAqE;EACrE,4DAA4D;EAC5D,oEAAoE;EACpE,mEAAmE;EACnE,wDAAwD;EACxD,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;IACI,8BAA8B;EAChC;AACF;EACE,kBAAkB;EAClB,wDAAwD;EACxD,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,gDAAgD;EAChD,gKAAgK;EAChK,wJAAwJ;EACxJ,iLAAiL;EACjL,wDAAwD;EACxD,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,oEAAoE;EACpE,oBAAoB;EACpB,+CAA+C;AACjD;AACA,cAAc;AACd;EACE,qEAAqE;EACrE,4DAA4D;EAC5D,oEAAoE;EACpE,mEAAmE;EACnE,wDAAwD;EACxD,6BAA6B;EAC7B,qBAAqB;EACrB,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;AAChC;AACA,2BAA2B;AAC3B;EACE,2BAA2B;AAC7B;AACA;;EAEE;sHACoH;AACtH;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,UAAU;EACV,yBAAyB;EACzB;mDACiD;AACnD;AACA;;EAEE;mDACiD;EACjD,UAAU;AACZ;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,UAAU;EACV;sHACoH;AACtH;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA,yBAAyB;AACzB;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;EACtB,wDAAwD;EACxD,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE;MACE,6BAA6B;MAC7B,8BAA8B;IAChC;EACF;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,MAAM;EACR;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;OAChB,gBAAgB;EACrB,YAAY;AACd;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,wDAAwD;EACxD,gKAAgK;EAChK,wJAAwJ;EACxJ,iLAAiL;EACjL,wDAAwD;EACxD,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,kCAAkC;EAClC,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;UACtB,sBAAsB;AAChC;AACA;EACE,2DAAiD;UACzC,mDAAyC;AACnD;AACA;EACE,2DAAkD;UAC1C,mDAA0C;AACpD;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,2DAAoD;UAC5C,mDAA4C;EACpD,0BAA0B;UAClB,kBAAkB;AAC5B;AACA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,wDAAwD;EACxD,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gKAAgK;EAChK,wJAAwJ;EACxJ,iLAAiL;EACjL,wDAAwD;EACxD,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,yDAAyD;EACzD,oBAAoB;EACpB,+CAA+C;AACjD;AACA;EACE;IACE,iBAAiB;IACjB,oBAAoB;IACpB,oBAAoB;EACtB;AACF;AACA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,0EAA0E;UAClE;AACV;AACA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;AACA;;;cAGc;AACd;EACE,oBAAoB;EACpB,gDAAgD;EAChD,6BAA6B;EAC7B,qBAAqB;EACrB,6DAA6D;EAC7D,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;AAChC;AACA,uCAAuC;AACvC;EACE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,WAAW;IACX,0BAA0B;YAClB,kBAAkB;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;AAEF;AACA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;EAC7C,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,0EAA0E;UAClE;AACV;AACA;EACE,kEAAkE;UAC1D,0DAA0D;AACpE;AACA,mBAAmB;AACnB;;;GAGG;AACH;EACE,6CAA6C;EAC7C,gCAAgC;AAClC;AACA;EACE;AACF;AACA;EACE,wCAAwC;EACxC,kCAAkC;AACpC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;AACA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;;;GAIG;AACH;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,2BAA2B;AAC7B;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA,kCAAkC;AAClC;EACE;IACE,cAAc;IACd,YAAY;EACd;AACF;AACA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,oBAAoB;AACtB;AACA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,gBAAgB;EAClB;AACF,2BAA2B;AAC3B;GACG,uCAAuC;CACzC;AACD;;;GAGG,6BAA6B;GAC7B,qBAAqB;GACrB,6DAA6D;GAC7D,4BAA4B;GAC5B,4BAA4B;GAC5B,uBAAuB;GACvB,+BAA+B;CACjC;AACD;;;;;;GAMG,8BAA8B;GAC9B,oBAAoB;CACtB;AACD,mCAAmC;AACnC;;;GAGG,+CAA+C;GAC/C,kBAAkB;GAClB,uCAAuC;CACzC;AACD;;;;;;GAMG,WAAW;GACX,kBAAkB;GAClB,OAAO;GACP,gBAAgB;GAChB,cAAc;GACd,WAAW;GACX,WAAW;GACX,iCAAiC;GACjC,qCAAqC;CACvC;AACD;;;GAGG,oBAAoB;GACpB,sBAAsB;CACxB;AACD;;;GAGG,uBAAuB;GACvB,uBAAuB;CACzB;AACD;;;GAGG,oBAAoB;GACpB,uBAAuB;CACzB;AACD;;;GAGG,oBAAoB;GACpB,oBAAoB;CACtB;AACD,8BAA8B;AAC9B;GACG,yBAAyB;CAC3B;AACD;;GAEG,kCAAkC;CACpC;AACD;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA,wBAAwB;AACxB;;EAEE;IACE,aAAa;IACb,gCAAgC;EAClC;;AAEF;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE;IACE,qBAAqB;SAChB,gBAAgB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;EACvB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA,gCAAgC;AAChC;EACE,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA,SAAS;AACT;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,wDAAwD;EACxD,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE;IACE,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE;MACE,mBAAmB;IACrB;EACF;AACF;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA,YAAY;AACZ;EACE,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;AACjD;AACA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,6CAA6C;AAC/C;AACA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA;;;;EAIE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;AAC/C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,yDAAyD;EACzD,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,6CAA6C;AAC/C;AACA;EACE,qBAAqB;AACvB;AACA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;EACzB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE;IACE,qBAAqB;IACrB,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,qBAAqB;OAChB,gBAAgB;AACvB;AACA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,qBAAqB;SAChB,gBAAgB;IACrB,aAAa;EACf;AACF;AACA,sBAAsB;AACtB;;EAEE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;EACV,gKAAgK;EAChK,wJAAwJ;EACxJ,iLAAiL;EACjL,wDAAwD;EACxD,0BAA0B;AAC5B;AACA;;;EAGE,YAAY;AACd;AACA;;;GAGG;AACH;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;OAClB,kBAAkB;EACvB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;AAC/C;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,wDAAwD;EACxD,WAAW;EACX,qBAAqB;EACrB,kCAAkC;EAClC,wBAAwB;EACxB,4BAA4B;EAC5B,2DAAiD;UACzC,mDAAyC;EACjD,0BAA0B;AAC5B;AACA;EACE,yDAA6C;EAC7C,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,6CAA6C;AAC/C;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE;IACE,uBAAuB;IACvB,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;AACA,uBAAuB;AACvB;EACE,qBAAqB;AACvB;AACA;;EAEE,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,gKAAgK;EAChK,wJAAwJ;EACxJ,iLAAiL;EACjL,wDAAwD;EACxD,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,wDAAwD;EACxD,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;EAC/C,gKAAgK;EAChK,wJAAwJ;EACxJ,iLAAiL;EACjL,wDAAwD;EACxD,0BAA0B;AAC5B;AACA;;EAEE,kBAAkB;EAClB,wDAAwD;EACxD,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE;;IAEE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,yDAA+C;EAC/C,4BAA4B;EAC5B,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,aAAa;EACb,4EAA4E;AAC9E;AACA;EACE,kBAAkB;EAClB,wDAAwD;EACxD,oBAAoB;EACpB,gDAAgD;AAClD;AACA,mDAAmD;AACnD;EACE,qBAAqB;OAChB,gBAAgB;AACvB;AACA;;;EAGE,eAAe;AACjB;AACA;IACI;IACA,eAAe;EACjB;AACF;AACA;;;;EAIE,kBAAkB;EAClB,sDAAsD;EACtD,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,gDAAgD;EAChD,+CAA+C;EAC/C,oBAAoB;EACpB,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,4BAA4B;AAC9B;AACA,eAAe;AACf;;EAEE,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;AACA;;;;EAIE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,yDAAyD;EACzD,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,gDAAgD;AAClD;AACA,WAAW;AACX;;;EAGE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;EAChD,oBAAoB;EACpB,kCAAkC;EAClC,wBAAwB;EACxB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;IACI,uBAAuB;IACvB,eAAe;EACjB;AACF;;;EAGE,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,WAAW;AACb;AACA,eAAe;AACf;;EAEE;;IAEE,6BAA6B;EAC/B;;EAEA,eAAe;EACf;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;EAC7B;AACF;AACA,mBAAmB;AACnB,aAAa;AACb,8BAA8B;AAC9B;EACE,aAAa;AACf;AACA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;AACA,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,qCAAqC;EACrC,cAAc;AAChB;AACA;;EAEE,yDAAyD;EACzD,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;AACA,2DAA2D;AAC3D;;;EAGE,yBAAyB;EACzB,gBAAgB;AAClB;AACA,iBAAiB;AACjB;;;;;;;;;;;GAWG;AACH;;;;CAIC;AACD;EACE,2DAA2D;UACnD,mDAAmD;EAC3D,mCAAmC;EACnC,mFAAmF;AACrF;AACA;EACE,qBAAqB;AACvB;AACA;;CAEC;AACD;;EAEE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE;IACE;MACE,gCAAgC;MAChC,iCAAiC;IACnC;EACF;AACF;AACA;EACE,0CAA0C;AAC5C;AACA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,wBAAwB;EAC1B;;AAEF;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA,sEAAsE;AACtE;EACE,qBAAqB;AACvB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA,uCAAuC;AACvC;EACE,4BAA4B;AAC9B;AACA;IACI,YAAY;EACd;AACF;MACM,YAAY;IACd;AACJ;IACI,aAAa;IACb,mBAAmB;EACrB;AACF;EACE;IACE;MACE,kBAAkB;MAClB,mBAAmB;IACrB;EACF;EACA;IACE,4BAA4B;IAC5B,eAAe;EACjB;AACF;AACA,kBAAkB;AAClB;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;EAChC;;IAEE;MACE,cAAc;IAChB;AACJ;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gDAAgD;EAClD;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gDAAgD;EAClD;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* @tailwind base;\n@tailwind components;\n@tailwind utilities; */\n/* ! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com */\n/*\n1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n*/\n*,\n::before,\n::after {\n  box-sizing: border-box; /* 1 */\n  border-width: 0; /* 2 */\n  border-style: solid; /* 2 */\n  border-color: currentColor; /* 2 */\n}\n::before,\n::after {\n  --tw-content: '';\n}\n/*\n1. Use a consistent sensible line-height in all browsers.\n2. Prevent adjustments of font size after orientation changes in iOS.\n3. Use a more readable tab size.\n4. Use the user's configured `sans` font-family by default.\n5. Use the user's configured `sans` font-feature-settings by default.\n6. Use the user's configured `sans` font-variation-settings by default.\n*/\nhtml {\n  line-height: 1.5; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  -moz-tab-size: 4; /* 3 */\n  tab-size: 4; /* 3 */\n  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"; /* 4 */\n  font-feature-settings: normal; /* 5 */\n  font-variation-settings: normal; /* 6 */\n}\n/*\n1. Remove the margin in all browsers.\n2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.\n*/\nbody {\n  margin: 0; /* 1 */\n  line-height: inherit; /* 2 */\n}\n/*\n1. Add the correct height in Firefox.\n2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n3. Ensure horizontal rules are visible by default.\n*/\nhr {\n  height: 0; /* 1 */\n  color: inherit; /* 2 */\n  border-top-width: 1px; /* 3 */\n}\n/*\nAdd the correct text decoration in Chrome, Edge, and Safari.\n*/\nabbr:where([title]) {\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n}\n/*\nRemove the default font size and weight for headings.\n*/\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n/*\nReset links to optimize for opt-in styling instead of opt-out.\n*/\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n/*\nAdd the correct font weight in Edge and Safari.\n*/\nb,\nstrong {\n  font-weight: bolder;\n}\n/*\n1. Use the user's configured `mono` font family by default.\n2. Correct the odd `em` font sizing in all browsers.\n*/\ncode,\nkbd,\nsamp,\npre {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n/*\nAdd the correct font size in all browsers.\n*/\nsmall {\n  font-size: 80%;\n}\n/*\nPrevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\n/*\n1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n3. Remove gaps between table borders by default.\n*/\ntable {\n  text-indent: 0; /* 1 */\n  border-color: inherit; /* 2 */\n  border-collapse: collapse; /* 3 */\n}\n/*\n1. Change the font styles in all browsers.\n2. Remove the margin in Firefox and Safari.\n3. Remove default padding in all browsers.\n*/\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-feature-settings: inherit; /* 1 */\n  font-variation-settings: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  font-weight: inherit; /* 1 */\n  line-height: inherit; /* 1 */\n  color: inherit; /* 1 */\n  margin: 0; /* 2 */\n  padding: 0; /* 3 */\n}\n/*\nRemove the inheritance of text transform in Edge and Firefox.\n*/\nbutton,\nselect {\n  text-transform: none;\n}\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Remove default button styles.\n*/\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n  -webkit-appearance: button; /* 1 */\n  background-color: transparent; /* 2 */\n  background-image: none; /* 2 */\n}\n/*\nUse the modern Firefox focus style for all focusable elements.\n*/\n:-moz-focusring {\n  outline: auto;\n}\n/*\nRemove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n/*\nAdd the correct vertical alignment in Chrome and Firefox.\n*/\nprogress {\n  vertical-align: baseline;\n}\n/*\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n/*\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/\n[type='search'] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n/*\nRemove the inner padding in Chrome and Safari on macOS.\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Change font properties to `inherit` in Safari.\n*/\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n/*\nAdd the correct display in Chrome and Safari.\n*/\nsummary {\n  display: list-item;\n}\n/*\nRemoves the default spacing and border for appropriate elements.\n*/\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\nfieldset {\n  margin: 0;\n  padding: 0;\n}\nlegend {\n  padding: 0;\n}\nol,\nul,\nmenu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n/*\nReset default styling for dialogs.\n*/\ndialog {\n  padding: 0;\n}\n/*\nPrevent resizing textareas horizontally by default.\n*/\ntextarea {\n  resize: vertical;\n}\n/*\n1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n2. Set the default placeholder color to the user's configured gray 400 color.\n*/\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1; /* 1 */\n  color: #9ca3af; /* 2 */\n}\n/*\nSet the default cursor for buttons.\n*/\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n/*\nMake sure disabled buttons don't get the pointer cursor.\n*/\n:disabled {\n  cursor: default;\n}\n/*\n1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n   This can trigger a poorly considered lint error in some tools but is included by design.\n*/\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block; /* 1 */\n  vertical-align: middle; /* 2 */\n}\n/*\nConstrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n/* Make elements with the HTML hidden attribute stay hidden by default */\n[hidden] {\n  display: none;\n}\n*, ::before, ::after {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n}\n::backdrop {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n}\n.container {\n  width: 100%;\n}\n@media (min-width: 640px) {\n  .container {\n    max-width: 640px;\n  }\n}\n@media (min-width: 768px) {\n  .container {\n    max-width: 768px;\n  }\n}\n@media (min-width: 1024px) {\n  .container {\n    max-width: 1024px;\n  }\n}\n@media (min-width: 1280px) {\n  .container {\n    max-width: 1280px;\n  }\n}\n@media (min-width: 1536px) {\n  .container {\n    max-width: 1536px;\n  }\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n.collapse {\n  visibility: collapse;\n}\n.static {\n  position: static;\n}\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n.mb-14 {\n  margin-bottom: 3.5rem;\n}\n.ml-\\[unset\\] {\n  margin-left: unset;\n}\n.mt-14 {\n  margin-top: 3.5rem;\n}\n.mt-4 {\n  margin-top: 1rem;\n}\n.block {\n  display: block;\n}\n.flex {\n  display: flex;\n}\n.table {\n  display: table;\n}\n.grid {\n  display: grid;\n}\n.contents {\n  display: contents;\n}\n.hidden {\n  display: none;\n}\n.min-h-\\[36px\\] {\n  min-height: 36px;\n}\n.w-full {\n  width: 100%;\n}\n.max-w-\\[1418px\\] {\n  max-width: 1418px;\n}\n.max-w-\\[70\\%\\] {\n  max-width: 70%;\n}\n.max-w-\\[80\\%\\] {\n  max-width: 80%;\n}\n.max-w-\\[90\\%\\] {\n  max-width: 90%;\n}\n.table-auto {\n  table-layout: auto;\n}\n.border-collapse {\n  border-collapse: collapse;\n}\n.grid-cols-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n.grid-cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.flex-col {\n  flex-direction: column;\n}\n.items-center {\n  align-items: center;\n}\n.justify-center {\n  justify-content: center;\n}\n.gap-6 {\n  gap: 1.5rem;\n}\n.gap-y-16 {\n  row-gap: 4rem;\n}\n.border {\n  border-width: 1px;\n}\n.bg-primary {\n  --tw-bg-opacity: 1;\n  background-color: rgb(19 68 83 / var(--tw-bg-opacity));\n}\n.p-2 {\n  padding: 0.5rem;\n}\n.p-3 {\n  padding: 0.75rem;\n}\n.p-4 {\n  padding: 1rem;\n}\n.px-5 {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n.py-16 {\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n.pb-6 {\n  padding-bottom: 1.5rem;\n}\n.text-center {\n  text-align: center;\n}\n.font-display {\n  font-family: \"OCRA\";\n}\n.text-white {\n  --tw-text-opacity: 1;\n  color: rgb(254 254 254 / var(--tw-text-opacity));\n}\n.shadow {\n  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n.outline {\n  outline-style: solid;\n}\n.drop-shadow {\n  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n}\n.filter {\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n}\n.transition {\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\nhtml {\n  scroll-behavior: smooth;\n}\nbody {\n  --tw-bg-opacity: 1;\n  background-color: rgb(254 254 254 / var(--tw-bg-opacity));\n  font-family: \"Inter\";\n  --tw-text-opacity: 1;\n  color: rgb(19 68 83 / var(--tw-text-opacity));\n  --tablet-breakpoint: 1024px;\n  --phone-breakpoint: 768px;\n  font-size: 100%;\n  scroll-behavior: smooth;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n#app {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n}\n/* background and page heading according to selected theme */\n#app.dark-indigo {\n  --tw-bg-opacity: 1;\n  background-color: rgb(30 109 133 / var(--tw-bg-opacity));\n}\n#app.dark-indigo .page-header {\n  --tw-text-opacity: 1;\n  color: rgb(234 213 179 / var(--tw-text-opacity));\n}\n#app.lighter-gold {\n  --tw-bg-opacity: 1;\n  background-color: rgb(251 246 239 / var(--tw-bg-opacity));\n}\n#app.lighter-gold .page-header {\n  --tw-text-opacity: 1;\n  color: rgb(13 48 58 / var(--tw-text-opacity));\n}\n#app.white {\n  --tw-bg-opacity: 1;\n  background-color: rgb(254 254 254 / var(--tw-bg-opacity));\n}\n#app.white .page-header {\n  --tw-text-opacity: 1;\n  color: rgb(13 48 58 / var(--tw-text-opacity));\n}\nfooter {\n  margin-top: auto;\n}\n*:focus-visible {\n  outline-width: 1px;\n  outline-offset: 4px;\n  outline-color: #449FBB;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: 'OCRA', sans-serif;\n  line-height: normal;\n}\nh4 {\n  font-size: 1.375rem;\n}\np {}\n@font-face {\n  font-family: 'OCRA';\n  src: url('../fonts/ocr-a-extended/font.woff2') format(\"woff2\");\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"OCRA\";\n}\n/* Make all typography responsive: */\n/* Overwrite all WP typography variables on mobile */\nbody {\n  --wp--preset--font-size--small: calc(13px * 0.8);\n  --wp--preset--font-size--medium: calc(20px * 0.8);\n  --wp--preset--font-size--large: calc(36px * 0.8);\n  --wp--preset--font-size--x-large: calc(42px * 0.8);\n  --wp--preset--font-size--heading-3-xl: calc(3.5rem * 0.8);\n  --wp--preset--font-size--heading-2-xl: calc(3rem * 0.8);\n  --wp--preset--font-size--heading-xl: calc(2.25rem * 0.8);\n  --wp--preset--font-size--heading-tablet: calc(2.3rem * 0.8);\n  --wp--preset--font-size--heading-mobile: calc(1.875rem * 0.8);\n  --wp--preset--font-size--heading-l: calc(1.625rem * 0.8);\n  --wp--preset--font-size--heading: calc(1.375rem * 0.8);\n  --wp--preset--font-size--heading-s: calc(1rem * 0.8);\n  --wp--preset--font-size--xl: calc(1.5rem * 0.8);\n  --wp--preset--font-size--l: calc(1.25rem * 0.8);\n  --wp--preset--font-size--normal: calc(1.125rem * 0.8);\n  --wp--preset--font-size--s: calc(1rem * 0.8);\n  --wp--preset--font-size--xs: calc(0.875rem * 0.8);\n\n}\n/* Overwrite all WP typography variables on tablet */\n@media screen and (min-width: 768px) {\n  body {\n    --wp--preset--font-size--small: calc(13px * 0.9);\n    --wp--preset--font-size--medium: calc(20px * 0.9);\n    --wp--preset--font-size--large: calc(36px * 0.9);\n    --wp--preset--font-size--x-large: calc(42px * 0.9);\n    --wp--preset--font-size--heading-3-xl: calc(3.5rem * 0.9);\n    --wp--preset--font-size--heading-2-xl: calc(3rem * 0.9);\n    --wp--preset--font-size--heading-xl: calc(2.25rem * 0.9);\n    --wp--preset--font-size--heading-tablet: calc(2.3rem * 0.9);\n    --wp--preset--font-size--heading-mobile: calc(1.875rem * 0.9);\n    --wp--preset--font-size--heading-l: calc(1.625rem * 0.9);\n    --wp--preset--font-size--heading: calc(1.375rem * 0.9);\n    --wp--preset--font-size--heading-s: calc(1rem * 0.9);\n    --wp--preset--font-size--xl: calc(1.5rem * 0.9);\n    --wp--preset--font-size--l: calc(1.25rem * 0.9);\n    --wp--preset--font-size--normal: calc(1.125rem * 0.9);\n    --wp--preset--font-size--s: calc(1rem * 0.9);\n    --wp--preset--font-size--xs: calc(0.875rem * 0.9);\n  }\n}\n/* Overwrite all WP typography variables on large screens and up */\n@media screen and (min-width: 1024px) {\n  body {\n    --wp--preset--font-size--small: 13px;\n    --wp--preset--font-size--medium: 20px;\n    --wp--preset--font-size--large: 36px;\n    --wp--preset--font-size--x-large: 42px;\n    --wp--preset--font-size--heading-3-xl: 3.5rem;\n    --wp--preset--font-size--heading-2-xl: 3rem;\n    --wp--preset--font-size--heading-xl: 2.25rem;\n    --wp--preset--font-size--heading-tablet: 2.3rem;\n    --wp--preset--font-size--heading-mobile: 1.875rem;\n    --wp--preset--font-size--heading-l: 1.625rem;\n    --wp--preset--font-size--heading: 1.375rem;\n    --wp--preset--font-size--heading-s: 1rem;\n    --wp--preset--font-size--xl: 1.5rem;\n    --wp--preset--font-size--l: 1.25rem;\n    --wp--preset--font-size--normal: 1.125rem;\n    --wp--preset--font-size--s: 1rem;\n    --wp--preset--font-size--xs: 0.875rem;\n  }\n}\n@keyframes fadeInAnimation {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n.site-header .nav-primary {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  gap: 2.8125rem;\n  --tw-text-opacity: 1;\n  color: rgb(19 68 83 / var(--tw-text-opacity));\n}\n@media screen and (max-width: 1023px) {\n\n  .site-header:not(.mobile-menu--active) .nav-primary {\n    opacity: 0;\n  }\n\n  .site-header.mobile-menu--active .nav-primary {\n    display: flex;\n    flex-direction: column;\n    animation: fadeInAnimation 0.7s ease-out forwards;\n  }\n\n}\n@media (orientation: landscape) and (max-height: 600px) {\n  .site-menu-container {\n    padding: 120px 0 70px;\n    overflow: auto;\n    -ms-overflow-style: none;\n    /* Internet Explorer 10+ */\n    scrollbar-width: none;\n    /* Firefox */\n  }\n\n  .site-menu-container::-webkit-scrollbar {\n    display: none;\n    /* Safari and Chrome */\n  }\n\n}\n.nav-primary .nav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2.375rem;\n}\n.nav-primary .nav a {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n  font-family: \"OCRA\";\n  font-size: 1.5rem;\n  line-height: 2.25rem;\n}\n.nav-primary .nav--1 .nav a {\n  background-image: linear-gradient(to right, var(--tw-gradient-stops));\n  --tw-gradient-from: #1E6D85 var(--tw-gradient-from-position);\n  --tw-gradient-to: rgb(30 109 133 / 0) var(--tw-gradient-to-position);\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);\n  --tw-gradient-to: #1E6D85 var(--tw-gradient-to-position);\n  background-size: 0% 0.1875rem;\n  background-position-x: center;\n}\n.nav-primary .nav--1 .nav a:hover {\n    background-size: 70% 0.1875rem;\n  }\n.nav-primary .nav--2 .nav a {\n  --tw-bg-opacity: 1;\n  background-color: rgb(30 109 133 / var(--tw-bg-opacity));\n  padding-left: 1rem;\n  padding-right: 1rem;\n  font-size: 1.125rem;\n  line-height: 1.8rem;\n  text-transform: uppercase;\n  --tw-text-opacity: 1;\n  color: rgb(251 246 239 / var(--tw-text-opacity));\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 300ms;\n}\n.nav-primary .nav--2 .nav a:hover {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(254 254 254 / var(--tw-bg-opacity)) !important;\n  --tw-text-opacity: 1;\n  color: rgb(30 109 133 / var(--tw-text-opacity));\n}\n/* for menus */\n.nav-primary .nav--1 .current-menu-item a {\n  background-image: linear-gradient(to right, var(--tw-gradient-stops));\n  --tw-gradient-from: #1E6D85 var(--tw-gradient-from-position);\n  --tw-gradient-to: rgb(30 109 133 / 0) var(--tw-gradient-to-position);\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);\n  --tw-gradient-to: #1E6D85 var(--tw-gradient-to-position);\n  -webkit-text-decoration: none;\n  text-decoration: none;\n  background-position-x: center;\n  background-repeat: no-repeat;\n  background-size: 70% 0.1875rem;\n}\n/* animated menu -- start */\n.nc-int-menu-to-close {\n  --transition-duration: 0.5s;\n}\n.nc-int-menu-to-close :nth-child(1),\n.nc-int-menu-to-close :nth-child(2) {\n  transition: opacity 0s calc(var(--transition-duration) / 2),\n    transform calc(var(--transition-duration) / 2) calc(var(--transition-duration) / 2) cubic-bezier(0.86, 0, 0.07, 1);\n}\n.nc-int-menu-to-close :nth-child(1) {\n  transform-origin: 16px 9px;\n}\n.nc-int-menu-to-close :nth-child(2) {\n  transform-origin: 16px 23px;\n}\n.nc-int-menu-to-close :nth-child(3),\n.nc-int-menu-to-close :nth-child(4) {\n  opacity: 0;\n  transform-origin: 50% 50%;\n  transition: transform calc(var(--transition-duration) / 2) cubic-bezier(0.86, 0, 0.07, 1),\n    opacity 0s calc(var(--transition-duration) / 2);\n}\n.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(1),\n.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(2) {\n  transition: transform calc(var(--transition-duration) / 2) cubic-bezier(0.86, 0, 0.07, 1),\n    opacity 0s calc(var(--transition-duration) / 2);\n  opacity: 0;\n}\n.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(1) {\n  transform: translateY(7px);\n}\n.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(2) {\n  transform: translateY(-7px);\n}\n.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(3),\n.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(4) {\n  opacity: 1;\n  transition: opacity 0s calc(var(--transition-duration) / 2),\n    transform calc(var(--transition-duration) / 2) calc(var(--transition-duration) / 2) cubic-bezier(0.86, 0, 0.07, 1);\n}\n.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(3) {\n  transform: rotate(45deg);\n}\n.site-header.mobile-menu--active .nc-int-menu-to-close.nc-int-icon-state-b :nth-child(4) {\n  transform: rotate(-45deg);\n}\n/* animated menu -- end */\n.site-header {\n  display: flex;\n  height: 5.9rem;\n  align-items: center;\n  justify-content: center;\n  border-bottom-width: 0.275rem;\n  --tw-border-opacity: 1;\n  border-color: rgb(30 109 133 / var(--tw-border-opacity));\n  --tw-bg-opacity: 1;\n  background-color: rgb(251 246 239 / var(--tw-bg-opacity));\n}\n@media (min-width: 1024px) {\n  .site-header {\n    height: 7.5rem;\n  }\n}\n.site-header-container {\n  display: flex;\n  height: 3.8rem;\n  width: 100%;\n  max-width: 1420px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n@media (min-width: 1024px) {\n  .site-header-container {\n    margin-top: 0px;\n  }\n}\n@media screen and (max-width: 1468px) {\n  @media (min-width: 1024px) {\n    .site-header-container {\n      padding-left: 3rem !important;\n      padding-right: 3rem !important;\n    }\n  }\n}\n.site-logo-container {\n  position: absolute;\n  top: 0.75rem;\n  left: 1rem;\n}\n@media (min-width: 768px) {\n  .site-logo-container {\n    left: 3.25rem;\n  }\n}\n@media (min-width: 1024px) {\n  .site-logo-container {\n    position: static;\n  }\n}\n.site-menu-mobile-container {\n  height: 100%;\n}\n.toggle-main-menu-button {\n  visibility: visible;\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  display: inline-flex;\n  height: 3.375rem;\n  width: 3.375rem;\n  align-items: center;\n}\n@media (min-width: 768px) {\n  .toggle-main-menu-button {\n    right: 3rem;\n  }\n}\n@media (min-width: 1024px) {\n  .toggle-main-menu-button {\n    visibility: hidden;\n  }\n}\n.custom-logo-link {\n  display: block;\n}\n@media screen and (max-width: 1023px) {\n  .site-menu-container {\n    display: none;\n  }\n\n  .mobile-menu--active .site-menu-container {\n    display: block;\n  }\n\n  .site-logo-container img {\n    height: 3.7875rem;\n  }\n\n  .site-header {\n    transition: height 0.4s ease-in-out;\n  }\n\n  .mobile-menu-is-active {\n    position: fixed;\n  }\n\n  .site-header.mobile-menu--active {\n    height: 100svh;\n    position: absolute;\n    width: 100svw;\n    z-index: 999;\n    top: 0;\n  }\n\n  .site-header .site-header-container {\n    flex-direction: column;\n    height: 100%;\n    justify-content: center;\n    align-items: unset;\n    margin: 0;\n  }\n\n  .site-header.mobile-menu--active .site-logo-container {\n    align-self: flex-start;\n    justify-self: flex-start;\n  }\n\n  .site-header .nav {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n  }\n}\n.site-footer .nav {\n  display: grid;\n  row-gap: 0.5rem;\n  justify-content: center;\n}\n@media screen and (min-width: 767px) {\n  .site-footer .nav {\n    justify-content: start;\n  }\n}\n.site-footer .footer-column {\n  padding-left: 2rem;\n  padding-right: 2rem;\n  font-size: 1.25rem;\n  line-height: 2rem;\n}\n.site-footer .footer-column a {\n  --tw-text-opacity: 1;\n  color: rgb(109 180 202 / var(--tw-text-opacity));\n}\n.site-footer .footer-column a:hover {\n  --tw-text-opacity: 1;\n  color: rgb(254 254 254 / var(--tw-text-opacity));\n}\n.site-footer .footer-column.social-media .nav {\n  display: flex;\n  justify-content: center;\n  -moz-column-gap: 1rem;\n       column-gap: 1rem;\n  row-gap: 0px;\n}\n@media (min-width: 768px) {\n  .site-footer .footer-column.social-media .nav {\n    justify-content: flex-start;\n  }\n}\n.site-footer .social-media--item {\n  height: 2.5rem;\n  border-radius: 9px;\n}\n.site-footer .social-media--item::before {\n  height: 4rem;\n  width: 4rem;\n  --tw-bg-opacity: 1;\n  background-color: rgb(68 159 187 / var(--tw-bg-opacity));\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 300ms;\n}\n.site-footer .social-media--item:hover::before {\n  --tw-bg-opacity: 1;\n  background-color: rgb(251 246 239 / var(--tw-bg-opacity));\n}\n.site-footer .social-media--item::before {\n  content: '';\n  display: inline-block;\n  background-position: center center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n          mask-repeat: no-repeat;\n}\n.site-footer .social-media--linkedin::before {\n  -webkit-mask-image: url('../images/linkedin.svg');\n          mask-image: url('../images/linkedin.svg');\n}\n.site-footer .social-media--instagram::before {\n  -webkit-mask-image: url('../images/instagram.svg');\n          mask-image: url('../images/instagram.svg');\n}\n.site-footer .social-media--24hr::before {\n  width: 5rem;\n}\n@media (min-width: 768px) {\n  .site-footer .social-media--24hr::before {\n    width: 7rem;\n  }\n}\n.site-footer .social-media--24hr::before {\n  -webkit-mask-image: url('../images/24hr-footer.svg');\n          mask-image: url('../images/24hr-footer.svg');\n  -webkit-mask-size: contain;\n          mask-size: contain;\n}\n/* sign up button */\n.site-footer .footer-column.column--2 menu li {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  --tw-bg-opacity: 1;\n  background-color: rgb(30 109 133 / var(--tw-bg-opacity));\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  font-family: \"OCRA\";\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 300ms;\n}\n.site-footer .footer-column.column--2 menu li:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(251 246 239 / var(--tw-bg-opacity));\n  --tw-text-opacity: 1;\n  color: rgb(30 109 133 / var(--tw-text-opacity));\n}\n@media (min-width: 768px) {\n  .site-footer .footer-column.column--2 menu li {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    padding-left: 1.5rem;\n  }\n}\n.site-footer .footer-column.column--2 menu li {\n  display: inline-block;\n  padding-right: calc(1.5rem + 1.25rem);\n  -webkit-clip-path: polygon(0 0, 100% 0, calc(100% - 1.25rem) 100%, 0 100%);\n          clip-path: polygon(0 0, 100% 0, calc(100% - 1.25rem) 100%, 0 100%)\n}\n.site-footer .footer-column.column--2 menu li:hover a {\n  --tw-text-opacity: 1;\n  color: rgb(30 109 133 / var(--tw-text-opacity));\n}\n.site-footer .footer-column.column--2 menu li a {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  --tw-text-opacity: 1;\n  color: rgb(251 246 239 / var(--tw-text-opacity));\n}\n.site-footer .footer-column.column--2 menu li a:hover {\n  --tw-text-opacity: 1;\n  color: rgb(30 109 133 / var(--tw-text-opacity));\n}\n/* end\n\n\n/* for menus */\n.site-footer .column--1 .current-menu-item a {\n  --tw-text-opacity: 1;\n  color: rgb(251 246 239 / var(--tw-text-opacity));\n  -webkit-text-decoration: none;\n  text-decoration: none;\n  background-image: linear-gradient(currentColor, currentColor);\n  background-position: 0% 100%;\n  background-repeat: no-repeat;\n  background-size: 100% 0.125rem;\n}\n/* smaller icons and button on mobile */\n@media screen and (max-width:767px) {\n  .site-footer .footer-column.column--2 menu li a {\n    font-size: 1.225rem;\n    padding: 0.75rem;\n  }\n\n  .site-footer a.social-media--linkedin::before,\n  .site-footer a.social-media--instagram::before {\n    height: 3rem;\n    width: 3rem;\n    -webkit-mask-size: contain;\n            mask-size: contain;\n  }\n\n  .site-footer .footer-column.column--2 menu li {\n    padding-right: 2rem;\n  }\n\n}\n.button {\n  transition: all 0.3s ease-in-out;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  font-size: 1.375rem;\n  padding: 1rem 1.5rem;\n  background-color: var(--button-primary-color);\n  color: var(--primary-text-color);\n  font-family: 'OCRA';\n}\n.button.tilt-right {\n  -webkit-clip-path: polygon(0 0, 100% 0, calc(100% - 1.25rem) 100%, 0 100%);\n          clip-path: polygon(0 0, 100% 0, calc(100% - 1.25rem) 100%, 0 100%)\n}\n.button.tilt-left {\n  -webkit-clip-path: polygon(0% 0%, 100% 0, 100% 100%, 0.75rem 100%);\n          clip-path: polygon(0% 0%, 100% 0, 100% 100%, 0.75rem 100%);\n}\n/* color variants */\n/* .button:hover {\n  background-color: var(--secondary-text-color) !important;\n  color: var(--secondary-color) !important;\n} */\n.button.primary {\n  background-color: var(--button-primary-color);\n  color: var(--primary-text-color);\n}\n.button:hover, button.primary:hover {\n  background-color: var(--button-primary-hover)\n}\n.button.secondary {\n  background-color: var(--secondary-color);\n  color: var(--secondary-text-color);\n}\n.button.secondary:hover {\n  background-color: var(--button-dark-color);\n}\n.button.dark {\n  background-color: var(--dark-color);\n  color: var(--dark-text-color);\n}\n/* size variants */\n.button.large {\n  font-size: 1.375rem;\n  padding: 1rem 1.5rem;\n}\n.button.small {\n  font-size: 1.225rem;\n  padding: 0.75rem 1rem;\n}\n.button.tilt-right {\n    padding-right: calc(1.5rem + 1.25rem);\n}\n.button.small.tilt-right {\n    padding-right: calc(1rem + 1.25rem);\n}\n.button.tilt-left {\n  padding-left: calc(1.5rem + 0.75rem);\n}\n.button.small.tilt-left {\n  padding-left: calc(1rem + 0.75rem);\n}\n.page-header h1 {\n  margin-left: 0px;\n  margin-right: 0px;\n  max-width: 934px;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  padding-top: 4rem;\n  text-align: center;\n  font-family: \"OCRA\";\n  font-size: 1.875rem;\n}\n@media (min-width: 768px) {\n  .page-header h1 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n}\n@media (min-width: 1024px) {\n  .page-header h1 {\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 4rem;\n    padding-right: 4rem;\n    padding-top: 8.125rem;\n    text-align: center;\n    font-size: 3rem;\n    line-height: 3.6rem;\n  }\n}\n.page-header.page-header--hidden {\n  display: none;\n}\n.section {\n  margin-left: 1.25rem;\n  margin-right: 1.25rem;\n  max-width: 1420px;\n}\n/* .gutenberg {\n    @apply mx-8\n    md:mx-12\n    lg:mx-16;\n} */\n.paragraph.large {\n  max-width: 55rem;\n}\n.paragraph {\n  margin-left: 0px;\n  margin-right: 0px;\n  text-align: left;\n}\n@media (min-width: 1024px) {\n  .paragraph {\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n  }\n}\n.desktop-center-mobile-left {\n  text-align: left;\n}\n@media (min-width: 1024px) {\n  .desktop-center-mobile-left {\n    text-align: center;\n  }\n}\n.desktop-center-mobile-left--flex {\n  justify-content: flex-start;\n}\n@media (min-width: 1024px) {\n  .desktop-center-mobile-left--flex {\n    justify-content: center;\n  }\n}\n/* hero-text less wide on tablet */\n@media screen and (min-width: 600px) and (max-width: 1023px) {\n  .hero-text-container {\n    max-width: 80%;\n    margin: auto;\n  }\n}\n/* styling only for 404 page */\nbody.error404 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(251 246 239 / var(--tw-bg-opacity));\n}\nbody.error404 .page-header {\n  padding-bottom: 2rem;\n}\n:root {\n    --indigo-primary: #1e6d85;\n    --indigo-dark: #134453;\n    --gold-primary: #cdb285;\n    --gray-dark: #262626;\n    --white: #ffffff;\n  }\n/* styling for menu links */\nmenu p a {\n   color: var(--indigo-primary) !important;\n }\nmenu p a,\n .animated-underline a,\n .animated-underline {\n   -webkit-text-decoration: none;\n   text-decoration: none;\n   background-image: linear-gradient(currentColor, currentColor);\n   background-position: 0% 100%;\n   background-repeat: no-repeat;\n   background-size: 0% 2px;\n   transition: background-size .3s;\n }\nmenu p a:hover,\n .animated-underline a:hover,\n .animated-hover-item:hover .animated-underline,\n .animated-hover-item:focus .animated-underline,\n .animated-hover-item:active .animated-underline,\n .animated-hover-item:focus-visible .animated-underline {\n   background-size: 100% 0.125rem;\n   transition-delay: 0s;\n }\n/* styling for links in text body */\np:not(.menu)>a,\n .single-event .event-content-container li:not(.menu) a,\n a.body-link {\n   --ease-out-expo: cubic-bezier(0.19, 1, 0.22, 1);\n   position: relative;\n   color: var(--indigo-primary) !important;\n }\np:not(.menu)>a::before,\n p:not(.menu)>a::after,\n .single-event .event-content-container li:not(.menu) a::before,\n .single-event .event-content-container li:not(.menu) a::after,\n a.body-link::before,\n a.body-link::after {\n   content: \"\";\n   position: absolute;\n   left: 0;\n   bottom: -0.15rem;\n   display: block;\n   width: 100%;\n   height: 1px;\n   background: var(--indigo-primary);\n   transition: 0.5s var(--ease-out-expo);\n }\np:not(.menu)>a::before,\n .single-event .event-content-container li:not(.menu) a::before,\n a.body-link::before {\n   transform: scaleX(0);\n   transform-origin: left;\n }\np:not(.menu)>a::after,\n .single-event .event-content-container li:not(.menu) a::after,\n a.body-link::after {\n   transform-origin: right;\n   transition-delay: 0.25s;\n }\np:not(.menu)>a:hover::before,\n .single-event .event-content-container li:not(.menu) a:hover::before,\n a.body-link:hover::before {\n   transform: scaleX(1);\n   transition-delay: 0.25s;\n }\np:not(.menu)>a:hover::after,\n .single-event .event-content-container li:not(.menu) a:hover::after,\n a.body-link:hover::after {\n   transform: scaleX(0);\n   transition-delay: 0s;\n }\n/* for links with light text */\na.body-link.light-text {\n   color: inherit !important;\n }\na.body-link.light-text::before,\n a.body-link.light-text::after {\n   background-color: white !important;\n }\nbody:has(.single-event) {\n  --tw-bg-opacity: 1;\n  background-color: rgb(251 246 239 / var(--tw-bg-opacity));\n}\n.single-event .event-section {\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1420px;\n}\n/* grid for lg screens */\n@media screen and (min-width: 1024px) {\n\n  .single-event .event-content-container {\n    display: grid;\n    grid-template-columns: 1.5fr 1fr;\n  }\n\n}\n.single-event .event-section .event-content-container {\n  max-width: 1420px;\n  padding-top: 4rem;\n}\n@media (min-width: 1024px) {\n  .single-event .event-section .event-content-container {\n    -moz-column-gap: 4rem;\n         column-gap: 4rem;\n    padding-left: 3rem;\n    padding-right: 3rem;\n    padding-top: 8.375rem;\n  }\n}\n.single-event .event-info-container {\n  padding-left: 6svw;\n  padding-right: 6svw;\n}\n@media (min-width: 640px) {\n  .single-event .event-info-container {\n    padding-left: 10svw;\n    padding-right: 10svw;\n  }\n}\n@media screen and (min-width: 1024px) {\n  .single-event .event-info-container {\n    padding: unset;\n  }\n}\n/* event date location details */\n.single-event .event-details-container {\n  margin-bottom: 1.25rem;\n  font-size: 1.15rem;\n  --tw-text-opacity: 1;\n  color: rgb(254 254 254 / var(--tw-text-opacity));\n}\n.single-event .event-details-container td.event-details-label {\n  padding-right: 1rem;\n  --tw-text-opacity: 1;\n  color: rgb(234 213 179 / var(--tw-text-opacity));\n}\n.single-event .event-details-container tr.table-spacing td {\n  padding-bottom: 0.625rem;\n}\n.single-event .event-details-container table {\n  margin-bottom: 3.5rem;\n}\n@media (min-width: 1024px) {\n  .single-event .event-details-container table {\n    margin-bottom: 2.75rem;\n  }\n}\n.single-event .event-details-container table .event-details-label-col {\n  width: 30%;\n}\n.single-event .event-details-container table .full-width {\n  width: 100%;\n}\n.single-event .event-sponsor img {\n  height: auto;\n  width: 8rem;\n}\n@media (min-width: 768px) {\n  .single-event .event-sponsor img {\n    width: 10rem;\n  }\n}\n.single-event .event-extra-info {\n  margin-bottom: 1rem;\n  font-size: 1.125rem;\n  line-height: 1.8rem;\n  font-style: italic;\n}\n@media (min-width: 1024px) {\n  .single-event .event-extra-info {\n    margin-bottom: 2rem;\n  }\n}\n/* form */\n.event-form-container {\n  min-width: 24rem;\n  margin-bottom: 4rem;\n}\n.single-event .event-form-container .event-form {\n  position: sticky;\n  top: 1rem;\n  --tw-bg-opacity: 1;\n  background-color: rgb(30 109 133 / var(--tw-bg-opacity));\n  padding: 1.25rem;\n  font-family: \"Inter\";\n}\n@media (min-width: 1024px) {\n  .single-event .event-form-container .event-form {\n    border-radius: 1.5rem;\n    padding: 2.25rem;\n    padding-bottom: 4rem;\n  }\n}\n@media screen and (max-width: 1023px) {\n  .single-event .event-form-container .event-form {\n    padding-bottom: 4rem;\n  }\n\n  @media (min-width: 1024px) {\n    .single-event .event-form-container {\n      padding-right: 4rem;\n    }\n  }\n}\n.event-form-title {\n  margin-bottom: 2rem;\n  margin-top: 2.25rem;\n  font-size: 1.5rem;\n  line-height: 2.4rem;\n  --tw-text-opacity: 1;\n  color: rgb(254 254 254 / var(--tw-text-opacity));\n}\n@media (min-width: 1024px) {\n  .event-form-title {\n    margin-bottom: 2rem;\n    margin-top: 0px;\n  }\n}\n.single-event .event-form .fallback-message-container p.fallback-message {\n  padding-top: 1.5rem;\n  font-family: \"OCRA\";\n  font-size: 1.3rem;\n  font-weight: 500;\n  --tw-text-opacity: 1;\n  color: rgb(234 213 179 / var(--tw-text-opacity));\n}\n@media (min-width: 768px) {\n  .single-event .event-form .fallback-message-container p.fallback-message {\n    padding-top: 0px;\n    font-size: 1.5rem;\n  }\n}\n/* content */\n.single-event .event-title {\n  margin-bottom: 1.5rem;\n  font-size: 1.875rem;\n  --tw-text-opacity: 1;\n  color: rgb(30 109 133 / var(--tw-text-opacity));\n}\n@media (min-width: 768px) {\n  .single-event .event-title {\n    font-size: 2.3rem;\n    line-height: 2.7rem;\n  }\n}\n@media (min-width: 1024px) {\n  .single-event .event-title {\n    font-size: 3rem;\n    line-height: 3.6rem;\n  }\n}\n.single-event .event-ingress-container {\n  margin-bottom: 3.25rem;\n  max-width: 60rem;\n}\n.single-event .event-ingress-container * {\n  font-size: 1.25rem;\n  line-height: 2rem;\n  --tw-text-opacity: 1;\n  color: rgb(38 38 38 / var(--tw-text-opacity));\n}\n@media (min-width: 1024px) {\n  .single-event .event-ingress-container * {\n    font-size: 1.5rem;\n    line-height: 2.4rem;\n  }\n}\n.single-event .event-ingress-container ol,\n.single-event .event-ingress-container ul,\n.single-event .event-description-container ol,\n.single-event .event-description-container ul {\n  margin: 2em 0;\n  padding-left: 4rem;\n}\n.single-event .event-content-container ol {\n  list-style: decimal;\n}\n.single-event .event-content-container ul {\n  list-style: disc;\n}\n.single-event .event-ingress-container li,\n.single-event .event-description-container li {\n  margin-bottom: 0.3em;\n}\n.single-event .event-image-container img {\n  margin-bottom: 3rem;\n  width: 100%;\n  border-radius: 1.5rem;\n}\n.single-event .event-description-container {\n  margin-bottom: 3rem;\n  font-size: 1.125rem;\n  line-height: 1.8rem;\n  --tw-text-opacity: 1;\n  color: rgb(13 48 58 / var(--tw-text-opacity));\n}\n.single-event .event-sponsors-container {\n  margin-bottom: 4.5rem;\n}\n.single-event .event-sponsors-container fieldset {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-around;\n  row-gap: 2.5rem;\n  border-top-width: 1px;\n  border-bottom-width: 1px;\n  --tw-border-opacity: 1;\n  border-color: rgb(205 178 133 / var(--tw-border-opacity));\n  padding: 2.25rem;\n  padding-top: 2rem;\n}\n@media (min-width: 1024px) {\n  .single-event .event-sponsors-container fieldset {\n    flex-direction: row;\n  }\n}\n.single-event .event-sponsors-container fieldset legend {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  font-size: 0.875rem;\n  line-height: 1.225rem;\n  --tw-text-opacity: 1;\n  color: rgb(19 68 83 / var(--tw-text-opacity));\n}\n.single-event .event-extra-container {\n  margin-bottom: 4.5rem;\n}\n/* sponsors block */\n.event-sponsors-container {\n  margin-bottom: 3rem;\n}\nbody:has(.event-archive) {\n  --tw-bg-opacity: 1;\n  background-color: rgb(251 246 239 / var(--tw-bg-opacity));\n}\n.event-archive {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n}\n.event-list-wrapper {\n  text-align: center;\n}\n.event-archive-container {\n  margin-left: 2rem;\n  margin-right: 2rem;\n  margin-top: 4rem;\n  margin-bottom: 4rem;\n  width: 100%;\n  max-width: 1420px;\n}\n@media (min-width: 768px) {\n  .event-archive-container {\n    margin-left: 3rem;\n    margin-right: 3rem;\n  }\n}\n@media (min-width: 1024px) {\n  .event-archive-container {\n    margin-left: 4rem;\n    margin-right: 4rem;\n    margin-top: 8.375rem;\n    margin-bottom: 8.375rem;\n  }\n}\n.event-archive-info-container {\n  margin-bottom: 2rem;\n}\n.event-archive-title {\n  margin-bottom: 1.5rem;\n  font-family: \"OCRA\";\n  font-size: 1.875rem;\n}\n@media (min-width: 1024px) {\n  .event-archive-title {\n    margin-bottom: 0.5rem;\n    font-size: 3rem;\n    line-height: 3.6rem;\n  }\n}\n.event-archive-ingress-container {\n  margin-bottom: 3rem;\n  max-width: 60rem;\n}\n@media (min-width: 1024px) {\n  .event-archive-ingress-container {\n    margin-bottom: 4.5rem;\n  }\n}\n.event-archive-ingress {\n  font-size: 1.25rem;\n  line-height: 2rem;\n}\n@media (min-width: 1024px) {\n  .event-archive-ingress {\n    font-size: 1.5rem;\n    line-height: 2.4rem;\n  }\n}\n.event-list-wrapper .post-list-container {\n  display: grid;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n  row-gap: 2rem;\n  -moz-column-gap: 2rem;\n       column-gap: 2rem;\n}\n@media (min-width: 640px) {\n  .event-list-wrapper .post-list-container {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n@media (min-width: 1024px) {\n  .event-list-wrapper .post-list-container {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n@media (min-width: 1280px) {\n  .event-list-wrapper .post-list-container {\n    -moz-column-gap: 3rem;\n         column-gap: 3rem;\n    row-gap: 4rem;\n  }\n}\n/* single event item */\n.event-list-single-container,\n.event-list-single-container a {\n  border-radius: 1.5rem;\n}\n.event-list-single-container img,\n.event-list-single-container .image-placeholder {\n  aspect-ratio: 445/305;\n  width: 100%;\n  border-radius: 1.5rem;\n  object-fit: cover;\n  opacity: 1;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 300ms;\n}\n.event-list-single-container:hover img,\n.event-list-single-container:active img,\n.event-list-single-container:focus-visible img {\n  opacity: 85%;\n}\n/* .event-list-single-container img.passed-event-img {\n  -webkit-filter: grayscale(100%);\n  filter: grayscale(100%);\n} */\n.event-list-single-container .event-list-single-heading {\n  margin-bottom: 0.75rem;\n  text-align: start;\n  font-size: 1.625rem;\n  line-height: 1.95rem;\n  --tw-text-opacity: 1;\n  color: rgb(30 109 133 / var(--tw-text-opacity));\n}\n.event-list-single-container .event-list-single-date {\n  display: flex;\n  align-items: center;\n  -moz-column-gap: 0.5rem;\n       column-gap: 0.5rem;\n  font-size: 1rem;\n  line-height: 1.6rem;\n  --tw-text-opacity: 1;\n  color: rgb(19 68 83 / var(--tw-text-opacity));\n}\n.event-list-single-container .event-list-single-info-container {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n}\n.event-list-single-date span::before {\n  margin-inline-end: 0.5rem;\n  height: 1rem;\n  width: 1rem;\n  --tw-bg-opacity: 1;\n  background-color: rgb(30 109 133 / var(--tw-bg-opacity));\n  content: '';\n  display: inline-block;\n  background-position: center center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  -webkit-mask-image: url('/images/time-clock.svg');\n          mask-image: url('/images/time-clock.svg');\n  transform: translateY(2px);\n}\n.product-list-single-container .image-placeholder {\n  background-image: url('/images/logotype.svg');\n  background-size: 50%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.event-archive .button {\n  margin-top: 4rem;\n}\n[data-no-event-placeholder] {\n  font-family: \"OCRA\";\n  font-size: 1.2rem;\n  --tw-text-opacity: 1;\n  color: rgb(19 68 83 / var(--tw-text-opacity));\n}\n@media (min-width: 1024px) {\n  [data-no-event-placeholder] {\n    font-size: 1.5rem;\n  }\n}\n.person-archive {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n}\n.person-list-wrapper {\n  text-align: center;\n}\n.person-archive-container {\n  margin-left: 1.25rem;\n  margin-right: 1.25rem;\n  margin-top: 4rem;\n  margin-bottom: 4rem;\n  width: 100%;\n  max-width: 1420px;\n}\n@media (min-width: 1024px) {\n  .person-archive-container {\n    margin-top: 130px;\n    margin-bottom: 130px;\n  }\n}\n.person-archive-info-container {\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 4.365rem;\n  text-align: center;\n}\n@media (min-width: 1024px) {\n  .person-archive-info-container {\n    margin-bottom: 4.875rem;\n  }\n}\n.person-archive-title {\n  margin-bottom: 1.5rem;\n  font-family: \"OCRA\";\n  font-size: 1.875rem;\n}\n@media (min-width: 1024px) {\n  .person-archive-title {\n    margin-bottom: 0.875rem;\n    font-size: 3rem;\n    line-height: 3.6rem;\n  }\n}\n.person-archive-ingress-container {\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 3rem;\n  max-width: 860px;\n  font-size: 1.25rem;\n  line-height: 2rem;\n}\n@media (min-width: 1024px) {\n  .person-archive-ingress-container {\n    margin-bottom: 6.25rem;\n  }\n}\n.person-archive-container .post-filters-container {\n  margin-left: auto;\n  margin-right: auto;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n/* single person item */\n.person-list-single-container, .person-list-single-container a {\n  border-radius: 1.5rem;\n}\n.person-list-single-container img,\n.person-list-single-container .image-placeholder {\n  margin-bottom: 1.25rem;\n  aspect-ratio: 445/305;\n  width: 100%;\n  border-radius: 1.5rem;\n  object-fit: cover;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 300ms;\n}\n.post-filters {\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.5rem;\n}\n@media (min-width: 1024px) {\n  .post-filters {\n    justify-content: flex-start;\n  }\n}\n.post-filters button,\n.post-filter-select {\n  display: inline-block;\n  border-width: 1px;\n  border-style: solid;\n  --tw-border-opacity: 1;\n  border-color: rgb(30 109 133 / var(--tw-border-opacity));\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  font-family: \"OCRA\";\n  font-size: 1rem;\n  line-height: 1.6rem;\n  --tw-text-opacity: 1;\n  color: rgb(30 109 133 / var(--tw-text-opacity));\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 300ms;\n}\n.post-filters button:hover,\n.post-filter-select:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(30 109 133 / var(--tw-bg-opacity));\n  --tw-text-opacity: 1;\n  color: rgb(251 246 239 / var(--tw-text-opacity));\n}\n@media (min-width: 1024px) {\n  .post-filters button,\n.post-filter-select {\n    font-size: 1.125rem;\n    line-height: 1.8rem;\n  }\n}\n.post-filter-select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  /* Remove default arrow */\n  background-image: url('/images/down-arrow.svg');\n  background-repeat: no-repeat;\n  background-position: center right 9px;\n  padding-right: 35px;\n  background-size: 0.7rem;\n  border-radius: 0;\n  /* Add custom arrow */\n  --tw-bg-opacity: 1;\n  background-color: rgb(251 246 239 / var(--tw-bg-opacity));\n}\n.post-filter-select:hover {\n  background-color: unset;\n  color: unset;\n}\n.post-filter-select::-ms-expand {\n  display: none;\n  /* Hide the default arrow in Internet Explorer 10 and Internet Explorer 11 */\n}\n.post-filters button.is-current-filter {\n  --tw-bg-opacity: 1;\n  background-color: rgb(30 109 133 / var(--tw-bg-opacity));\n  --tw-text-opacity: 1;\n  color: rgb(251 246 239 / var(--tw-text-opacity));\n}\n/* target on blocks with the custom Contact block */\n.wp-block-group:has(.contact-block) {\n  -moz-column-gap: 4rem;\n       column-gap: 4rem;\n}\n.wp-container-4.wp-container-4:has(.contact-block),\n.wp-container-6.wp-container-6:has(.contact-block),\n.wp-container-8.wp-container-8:has(.contact-block) {\n  flex-wrap: wrap;\n}\n@media screen and (max-width: 1024px) {\n    .wp-block-group:has(.contact-block) {\n    flex-wrap: wrap;\n  }\n}\nform input,\nform textarea,\n.mc4wp-form-fields input,\n.mc4wp-form-fields select {\n  --tw-bg-opacity: 1;\n  background-color: rgb(19 68 83 / var(--tw-bg-opacity));\n  font-family: \"Inter\";\n  font-size: 1rem;\n  line-height: 1.6rem;\n  --tw-text-opacity: 1;\n  color: rgb(234 213 179 / var(--tw-text-opacity));\n  background-color: var(--indigo-dark) !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n}\nform input::placeholder, form textarea::placeholder, .mc4wp-form-fields input::placeholder, .mc4wp-form-fields select::placeholder {\n  --tw-text-opacity: 1;\n  color: rgb(234 213 179 / var(--tw-text-opacity));\n}\nform *:focus {\n  outline-style: solid;\n  outline-color: #CDB285;\n}\n.mauticform-textarea {\n  min-height: 104px !important;\n}\n/* mc4wp form */\n.mc4wp-form-fields input,\n.mc4wp-form-fields select {\n  margin-bottom: 20px;\n  width: 100%;\n  padding: 0.5em;\n}\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  transition-delay: 9999s;\n}\n.mc4wp-alert {\n  margin-top: 1rem;\n  display: flex;\n  justify-content: center;\n}\n.mc4wp-alert>p {\n  border-top-width: 1px;\n  border-bottom-width: 1px;\n  --tw-border-opacity: 1;\n  border-color: rgb(234 213 179 / var(--tw-border-opacity));\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n  text-align: center;\n  --tw-text-opacity: 1;\n  color: rgb(234 213 179 / var(--tw-text-opacity));\n}\n/* button */\nform button,\n.single-event .event-form button[type=button].eventbrite-button,\n.mc4wp-form-fields input[type=submit] {\n  width: 100%;\n  font-family: \"OCRA\";\n  font-weight: 400;\n  background-color: var(--gold-primary) !important;\n  border: 0 !important;\n  color: var(--gray-dark) !important;\n  padding: 1rem !important;\n  border-radius: 3px !important;\n  margin-top: 0.5em;\n  max-width: 40rem;\n}\nform button:hover, .single-event .event-form button[type=button].eventbrite-button:hover, .mc4wp-form-fields input[type=submit]:hover {\n    filter: brightness(90%);\n    cursor: pointer;\n  }\n.mauticform-button,\n.single-event .event-form button[type=button].eventbrite-button,\n.mc4wp-form-fields input[type=submit] {\n  font-weight: 400;\n  font-size: 1.375rem !important;\n  /* 22px */\n  line-height: 1.925rem !important;\n  /* 30.8px */\n}\n/* button end */\n@media screen and (max-width: 768px) {\n\n  .single-event .event-form button[type=button].eventbrite-button,\n  .mc4wp-form-fields input[type=submit] {\n    font-size: 1.15rem !important;\n  }\n\n  /* form width */\n  form {\n    width: 100% !important;\n    margin: 0 !important;\n  }\n\n  .mauticform_wrapper {\n    max-width: unset !important;\n  }\n}\n/* form width end */\n/* checkbox */\n/* Hide the default checkbox */\ninput[type=\"checkbox\"].mauticform-checkboxgrp-checkbox {\n  display: none;\n}\n/* Style for the custom checkbox */\n.mauticform-checkboxgrp-label {\n  position: relative;\n  padding-left: 30px;\n  cursor: pointer;\n  display: inline-block;\n  line-height: 1.5;\n}\n/* Style for the custom checkbox */\n.mauticform-checkboxgrp-label::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  height: 20px;\n  width: 20px;\n  background-color: transparent;\n  border: 1px solid var(--gold-primary);\n  display: block;\n}\n.mauticform-checkboxgrp-label::after,\n.mauticform-checkboxgrp-label::after {\n  /* currently not working on desktop for reasons unknown */\n  z-index: 10;\n  font-family: \"OCRA\";\n  content: \"\";\n  position: absolute;\n  top: -4px;\n  left: 3px;\n  color: white;\n  font-size: 22px;\n  display: block !important;\n}\n/* Show the custom checkmark when the checkbox is checked */\ninput[type=\"checkbox\"]:checked~.mauticform-checkboxgrp-label::after,\ninput[type=\"checkbox\"]:checked~.mauticform-checkboxgrp-label::after,\n.box-is-checked {\n  display: block !important;\n  content: \"\\2713\";\n}\n/* checkbox end */\n/* @media screen and (max-width: 1024px) {\n    .wp-block-cover {\n        min-height: unset !important;\n        padding: 0;\n\n        img {\n            position: relative !important;\n            height: auto !important;\n            width: 100% !important;\n        }\n    }\n} */\n/*\n !IMPORTANT!\n If you add classes here, please add a description of them in the documentation at:\n custom_classes_documentation_function() in services/wordpress/src/wp-content/themes/techella-wp/app/setup.php\n*/\n.diagonal-section {\n  -webkit-clip-path: polygon(0 20%, 100% 0, 100% 80%, 0 100%);\n          clip-path: polygon(0 20%, 100% 0, 100% 80%, 0 100%);\n  -webkit-backface-visibility: hidden;\n  /* This settings smoothes the edge out in Chrome - otherwise it looks very jagged */\n}\n.border-radius {\n  border-radius: 1.5rem;\n}\n/*\n*    Responsive\n*/\n.desktop-only,\n.desktop-only--flex {\n  display: none !important;\n}\n.mobile-only {\n  display: block !important;\n}\n.mobile-only--flex {\n  display: flex !important;\n}\n.section {\n  width: 100%;\n  max-width: 88.75rem;\n  margin-left: 1.25rem !important;\n  margin-right: 1.25rem !important;\n}\n@media screen and (max-width: 1420px) {\n  @media (min-width: 1024px) {\n    .section {\n      padding-left: 3.25rem !important;\n      padding-right: 3.25rem !important;\n    }\n  }\n}\n.drop-shadow {\n  filter: drop-shadow(24px 24px 0px #1E6D85);\n}\n@media screen and (min-width: 1024px) {\n  .desktop-only--flex {\n    display: flex !important;\n  }\n\n  .desktop-only {\n    display: block !important;\n  }\n\n  .mobile-only--flex,\n  .mobile-only {\n    display: none !important;\n  }\n\n}\n.wp-block-column.is-layout-flow.hero-text-container {\n  justify-content: flex-end;\n  overflow-y: auto;\n}\n/* funkar inte trots alla dessa klasser att inte använda !important: */\n.wp-block-column.is-layout-flow.hero-text-container .left-padding {\n  padding-left: 3.25rem;\n}\n@media screen and (min-width: 1500px) {\n  .wp-block-column.is-layout-flow.hero-text-container .wp-block-group.left-padding {\n    width: calc(1420px / 2);\n  }\n}\n.center-content {\n  display: flex;\n  justify-content: center;\n}\n/* only visible on 1024< screen width */\n.hero-section {\n  height: calc(100svh - 120px);\n}\n.hero-section .wp-block-column {\n    height: 100%;\n  }\n.hero-section .wp-block-column .wp-block-cover {\n      height: 100%;\n    }\n.hero-section .hero-text-container {\n    display: flex;\n    align-items: center;\n  }\n@media screen and (max-width: 1024px) {\n  @media (min-width: 768px) {\n    .social-icons-block .wp-block-cover {\n      padding-left: 5svw;\n      padding-right: 5svw;\n    }\n  }\n  .social-icons-block .wp-block-cover {\n    min-height: unset !important;\n    padding: 0 2svw;\n  }\n}\n/* Partners page */\n@media screen and (max-width: 600px) {\n  #partners-group .wp-block-media-text figure {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 1rem !important;\n  }\n\n    #partners-group .wp-block-media-text figure>img {\n      max-width: 70%;\n    }\n}\n@media screen and (min-width:601px) and (max-width: 980px) {\n  #partners-group .wp-block-media-text {\n    margin-left: 3rem !important;\n  }\n}\n#app {\n  position: relative;\n}\n.focus\\:not-sr-only:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  padding: 0;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n@media (min-width: 640px) {\n  .sm\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n@media (min-width: 768px) {\n  .md\\:mt-20 {\n    margin-top: 5rem;\n  }\n  .md\\:flex {\n    display: flex;\n  }\n  .md\\:max-w-\\[600px\\] {\n    max-width: 600px;\n  }\n  .md\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .md\\:justify-center {\n    justify-content: center;\n  }\n}\n@media (min-width: 1024px) {\n  .lg\\:ml-\\[3rem\\] {\n    margin-left: 3rem;\n  }\n  .lg\\:mt-24 {\n    margin-top: 6rem;\n  }\n  .lg\\:mt-\\[unset\\] {\n    margin-top: unset;\n  }\n  .lg\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n  .lg\\:flex-row {\n    flex-direction: row;\n  }\n  .lg\\:items-start {\n    align-items: flex-start;\n  }\n  .lg\\:justify-start {\n    justify-content: flex-start;\n  }\n  .lg\\:justify-between {\n    justify-content: space-between;\n  }\n  .lg\\:gap-y-0 {\n    row-gap: 0px;\n  }\n  .lg\\:px-0 {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n  .lg\\:text-left {\n    text-align: left;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
